var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_14421)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 0H5.41992V0.800435H6.19452V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 0H6.19336V0.800435H6.96796V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 0H6.9668V0.800435H7.7414V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 0H7.74219V0.800435H8.51679V0Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 0H8.51562V0.800435H9.29023V0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 0H9.29102V0.800435H10.0656V0Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 0H10.0645V0.800435H10.8391V0Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 0.800781H4.64453V1.60122H5.41913V0.800781Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 0.800781H5.41992V1.60122H6.19452V0.800781Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 0.800781H6.19336V1.60122H6.96796V0.800781Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 0.800781H6.9668V1.60122H7.7414V0.800781Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 0.800781H7.74219V1.60122H8.51679V0.800781Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 0.800781H8.51562V1.60122H9.29023V0.800781Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 0.800781H9.29102V1.60122H10.0656V0.800781Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 0.800781H10.0645V1.60122H10.8391V0.800781Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 0.800781H10.8398V1.60122H11.6144V0.800781Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 1.59961H3.87109V2.40004H4.64569V1.59961Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 1.59961H4.64453V2.40004H5.41913V1.59961Z",
    fill: "#F2F2F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 1.59961H5.41992V2.40004H6.19452V1.59961Z",
    fill: "#FFCF00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 1.59961H6.19336V2.40004H6.96796V1.59961Z",
    fill: "#FFCF00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 1.59961H6.9668V2.40004H7.7414V1.59961Z",
    fill: "#FFCF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 1.59961H7.74219V2.40004H8.51679V1.59961Z",
    fill: "#FFCF00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 1.59961H8.51562V2.40004H9.29023V1.59961Z",
    fill: "#FFCF00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 1.59961H9.29102V2.40004H10.0656V1.59961Z",
    fill: "#FFCF00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 1.59961H10.0645V2.40004H10.8391V1.59961Z",
    fill: "#FFCF00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 1.59961H10.8398V2.40004H11.6144V1.59961Z",
    fill: "#F2F2F2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 1.59961H11.6133V2.40004H12.3879V1.59961Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 2.40039H3.0957V3.20083H3.8703V2.40039Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 2.40039H3.87109V3.20083H4.64569V2.40039Z",
    fill: "#F2F2F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 2.40039H4.64453V3.20083H5.41913V2.40039Z",
    fill: "#FFCF00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 2.40039H5.41992V3.20083H6.19452V2.40039Z",
    fill: "#FFCF00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 2.40039H6.19336V3.20083H6.96796V2.40039Z",
    fill: "#FFCF00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 2.40039H6.9668V3.20083H7.7414V2.40039Z",
    fill: "#FFCF00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 2.40039H7.74219V3.20083H8.51679V2.40039Z",
    fill: "#FFCF00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 2.40039H8.51562V3.20083H9.29023V2.40039Z",
    fill: "#FFCF00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 2.40039H9.29102V3.20083H10.0656V2.40039Z",
    fill: "#FFCF00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 2.40039H10.0645V3.20083H10.8391V2.40039Z",
    fill: "#FFCF00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 2.40039H10.8398V3.20083H11.6144V2.40039Z",
    fill: "#FFCF00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 2.40039H11.6133V3.20083H12.3879V2.40039Z",
    fill: "#F2F2F2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 2.40039H12.3867V3.20083H13.1613V2.40039Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 2.40039H13.1602V3.20083H13.9348V2.40039Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 2.40039H13.9355V3.20083H14.7101V2.40039Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 2.40039H14.709V3.20083H15.4836V2.40039Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 2.40039H15.4844V3.20083H16.259V2.40039Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 2.40039H16.2578V3.20083H17.0324V2.40039Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 2.40039H17.0332V3.20083H17.8078V2.40039Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 2.40039H17.8066V3.20083H18.5812V2.40039Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 2.40039H18.5801V3.20083H19.3547V2.40039Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 2.40039H19.3555V3.20083H20.1301V2.40039Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 2.40039H20.1289V3.20083H20.9035V2.40039Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 2.40039H20.9043V3.20083H21.6789V2.40039Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 2.40039H21.6777V3.20083H22.4523V2.40039Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 3.19922H3.0957V3.99965H3.8703V3.19922Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 3.19922H3.87109V3.99965H4.64569V3.19922Z",
    fill: "#F2F2F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 3.19922H4.64453V3.99965H5.41913V3.19922Z",
    fill: "#FFCF00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 3.19922H5.41992V3.99965H6.19452V3.19922Z",
    fill: "#FFCF00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 3.19922H6.19336V3.99965H6.96796V3.19922Z",
    fill: "#FFCF00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 3.19922H6.9668V3.99965H7.7414V3.19922Z",
    fill: "#FFCF00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 3.19922H7.74219V3.99965H8.51679V3.19922Z",
    fill: "#FFCF00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 3.19922H8.51562V3.99965H9.29023V3.19922Z",
    fill: "#FFCF00"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 3.19922H9.29102V3.99965H10.0656V3.19922Z",
    fill: "#FFCF00"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 3.19922H10.0645V3.99965H10.8391V3.19922Z",
    fill: "#FFCF00"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 3.19922H10.8398V3.99965H11.6144V3.19922Z",
    fill: "#FFCF00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 3.19922H11.6133V3.99965H12.3879V3.19922Z",
    fill: "#FFCF00"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 3.19922H12.3867V3.99965H13.1613V3.19922Z",
    fill: "#F2F2F2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 3.19922H13.1602V3.99965H13.9348V3.19922Z",
    fill: "#F2F2F2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 3.19922H13.9355V3.99965H14.7101V3.19922Z",
    fill: "#F2F2F2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 3.19922H14.709V3.99965H15.4836V3.19922Z",
    fill: "#F2F2F2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 3.19922H15.4844V3.99965H16.259V3.19922Z",
    fill: "#F2F2F2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 3.19922H16.2578V3.99965H17.0324V3.19922Z",
    fill: "#F2F2F2"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 3.19922H17.0332V3.99965H17.8078V3.19922Z",
    fill: "#F2F2F2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 3.19922H17.8066V3.99965H18.5812V3.19922Z",
    fill: "#F2F2F2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 3.19922H18.5801V3.99965H19.3547V3.19922Z",
    fill: "#F2F2F2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 3.19922H19.3555V3.99965H20.1301V3.19922Z",
    fill: "#F2F2F2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 3.19922H20.1289V3.99965H20.9035V3.19922Z",
    fill: "#F2F2F2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 3.19922H20.9043V3.99965H21.6789V3.19922Z",
    fill: "#F2F2F2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 3.19922H21.6777V3.99965H22.4523V3.19922Z",
    fill: "#F2F2F2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 3.19922H22.4512V3.99965H23.2258V3.19922Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 4H3.0957V4.80044H3.8703V4Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 4H3.87109V4.80044H4.64569V4Z",
    fill: "#F2F2F2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 4H4.64453V4.80044H5.41913V4Z",
    fill: "#FFCF00"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 4H5.41992V4.80044H6.19452V4Z",
    fill: "#FFCF00"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 4H6.19336V4.80044H6.96796V4Z",
    fill: "#FFCF00"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 4H6.9668V4.80044H7.7414V4Z",
    fill: "#FFCF00"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 4H7.74219V4.80044H8.51679V4Z",
    fill: "#FFCF00"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 4H8.51562V4.80044H9.29023V4Z",
    fill: "#FFCF00"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 4H9.29102V4.80044H10.0656V4Z",
    fill: "#FFCF00"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 4H10.0645V4.80044H10.8391V4Z",
    fill: "#FFCF00"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 4H10.8398V4.80044H11.6144V4Z",
    fill: "#FFCF00"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 4H11.6133V4.80044H12.3879V4Z",
    fill: "#FFCF00"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 4H12.3867V4.80044H13.1613V4Z",
    fill: "#FFCF00"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 4H13.1602V4.80044H13.9348V4Z",
    fill: "#FFCF00"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 4H13.9355V4.80044H14.7101V4Z",
    fill: "#FFCF00"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 4H14.709V4.80044H15.4836V4Z",
    fill: "#FFCF00"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 4H15.4844V4.80044H16.259V4Z",
    fill: "#FFCF00"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 4H16.2578V4.80044H17.0324V4Z",
    fill: "#FFCF00"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 4H17.0332V4.80044H17.8078V4Z",
    fill: "#FFCF00"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 4H17.8066V4.80044H18.5812V4Z",
    fill: "#FFCF00"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 4H18.5801V4.80044H19.3547V4Z",
    fill: "#FFCF00"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 4H19.3555V4.80044H20.1301V4Z",
    fill: "#FFCF00"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 4H20.1289V4.80044H20.9035V4Z",
    fill: "#FFCF00"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 4H20.9043V4.80044H21.6789V4Z",
    fill: "#FFCF00"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 4H21.6777V4.80044H22.4523V4Z",
    fill: "#FFCF00"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 4H22.4512V4.80044H23.2258V4Z",
    fill: "#F2F2F2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 4H23.2246V4.80044H23.9992V4Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 4.80078H3.0957V5.60122H3.8703V4.80078Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 4.80078H3.87109V5.60122H4.64569V4.80078Z",
    fill: "#F2F2F2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 4.80078H4.64453V5.60122H5.41913V4.80078Z",
    fill: "#FFCF00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 4.80078H5.41992V5.60122H6.19452V4.80078Z",
    fill: "#FFCF00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 4.80078H6.19336V5.60122H6.96796V4.80078Z",
    fill: "#FFCF00"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 4.80078H6.9668V5.60122H7.7414V4.80078Z",
    fill: "#FFCF00"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 4.80078H7.74219V5.60122H8.51679V4.80078Z",
    fill: "#FFCF00"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 4.80078H8.51562V5.60122H9.29023V4.80078Z",
    fill: "#FFCF00"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 4.80078H9.29102V5.60122H10.0656V4.80078Z",
    fill: "#FFCF00"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 4.80078H10.0645V5.60122H10.8391V4.80078Z",
    fill: "#FFCF00"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 4.80078H10.8398V5.60122H11.6144V4.80078Z",
    fill: "#FFCF00"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 4.80078H11.6133V5.60122H12.3879V4.80078Z",
    fill: "#FFCF00"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 4.80078H12.3867V5.60122H13.1613V4.80078Z",
    fill: "#FFCF00"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 4.80078H13.1602V5.60122H13.9348V4.80078Z",
    fill: "#FFCF00"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 4.80078H13.9355V5.60122H14.7101V4.80078Z",
    fill: "#FFCF00"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 4.80078H14.709V5.60122H15.4836V4.80078Z",
    fill: "#FFCF00"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 4.80078H15.4844V5.60122H16.259V4.80078Z",
    fill: "#FFCF00"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 4.80078H16.2578V5.60122H17.0324V4.80078Z",
    fill: "#FFCF00"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 4.80078H17.0332V5.60122H17.8078V4.80078Z",
    fill: "#FFCF00"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 4.80078H17.8066V5.60122H18.5812V4.80078Z",
    fill: "#FFCF00"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 4.80078H18.5801V5.60122H19.3547V4.80078Z",
    fill: "#FFCF00"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 4.80078H19.3555V5.60122H20.1301V4.80078Z",
    fill: "#FFCF00"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 4.80078H20.1289V5.60122H20.9035V4.80078Z",
    fill: "#FFCF00"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 4.80078H20.9043V5.60122H21.6789V4.80078Z",
    fill: "#FFCF00"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 4.80078H21.6777V5.60122H22.4523V4.80078Z",
    fill: "#FFCF00"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 4.80078H22.4512V5.60122H23.2258V4.80078Z",
    fill: "#EDA507"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 4.80078H23.2246V5.60122H23.9992V4.80078Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 5.59961H3.0957V6.40004H3.8703V5.59961Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 5.59961H3.87109V6.40004H4.64569V5.59961Z",
    fill: "#EDA507"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 5.59961H4.64453V6.40004H5.41913V5.59961Z",
    fill: "#EDA507"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 5.59961H5.41992V6.40004H6.19452V5.59961Z",
    fill: "#EDA507"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 5.59961H6.19336V6.40004H6.96796V5.59961Z",
    fill: "#EDA507"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 5.59961H6.9668V6.40004H7.7414V5.59961Z",
    fill: "#EDA507"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 5.59961H7.74219V6.40004H8.51679V5.59961Z",
    fill: "#EDA507"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 5.59961H8.51562V6.40004H9.29023V5.59961Z",
    fill: "#EDA507"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 5.59961H9.29102V6.40004H10.0656V5.59961Z",
    fill: "#EDA507"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 5.59961H10.0645V6.40004H10.8391V5.59961Z",
    fill: "#EDA507"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 5.59961H10.8398V6.40004H11.6144V5.59961Z",
    fill: "#EDA507"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 5.59961H11.6133V6.40004H12.3879V5.59961Z",
    fill: "#EDA507"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 5.59961H12.3867V6.40004H13.1613V5.59961Z",
    fill: "#EDA507"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 5.59961H13.1602V6.40004H13.9348V5.59961Z",
    fill: "#EDA507"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 5.59961H13.9355V6.40004H14.7101V5.59961Z",
    fill: "#EDA507"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 5.59961H14.709V6.40004H15.4836V5.59961Z",
    fill: "#EDA507"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 5.59961H15.4844V6.40004H16.259V5.59961Z",
    fill: "#EDA507"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 5.59961H16.2578V6.40004H17.0324V5.59961Z",
    fill: "#EDA507"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 5.59961H17.0332V6.40004H17.8078V5.59961Z",
    fill: "#EDA507"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 5.59961H17.8066V6.40004H18.5812V5.59961Z",
    fill: "#EDA507"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 5.59961H18.5801V6.40004H19.3547V5.59961Z",
    fill: "#EDA507"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 5.59961H19.3555V6.40004H20.1301V5.59961Z",
    fill: "#FFCF00"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 5.59961H20.1289V6.40004H20.9035V5.59961Z",
    fill: "#FFCF00"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 5.59961H20.9043V6.40004H21.6789V5.59961Z",
    fill: "#FFCF00"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 5.59961H21.6777V6.40004H22.4523V5.59961Z",
    fill: "#FFCF00"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 5.59961H22.4512V6.40004H23.2258V5.59961Z",
    fill: "#EDA507"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 5.59961H23.2246V6.40004H23.9992V5.59961Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54999 6.40039H0.775391V7.20083H1.54999V6.40039Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 6.40039H1.54883V7.20083H2.32343V6.40039Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 6.40039H2.32227V7.20083H3.09687V6.40039Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 6.40039H3.0957V7.20083H3.8703V6.40039Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 6.40039H3.87109V7.20083H4.64569V6.40039Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 6.40039H4.64453V7.20083H5.41913V6.40039Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 6.40039H5.41992V7.20083H6.19452V6.40039Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 6.40039H6.19336V7.20083H6.96796V6.40039Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 6.40039H6.9668V7.20083H7.7414V6.40039Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 6.40039H7.74219V7.20083H8.51679V6.40039Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 6.40039H8.51562V7.20083H9.29023V6.40039Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 6.40039H9.29102V7.20083H10.0656V6.40039Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 6.40039H10.0645V7.20083H10.8391V6.40039Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 6.40039H10.8398V7.20083H11.6144V6.40039Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 6.40039H11.6133V7.20083H12.3879V6.40039Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 6.40039H12.3867V7.20083H13.1613V6.40039Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 6.40039H13.1602V7.20083H13.9348V6.40039Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 6.40039H13.9355V7.20083H14.7101V6.40039Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 6.40039H14.709V7.20083H15.4836V6.40039Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 6.40039H15.4844V7.20083H16.259V6.40039Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 6.40039H16.2578V7.20083H17.0324V6.40039Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 6.40039H17.0332V7.20083H17.8078V6.40039Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 6.40039H17.8066V7.20083H18.5812V6.40039Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 6.40039H18.5801V7.20083H19.3547V6.40039Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 6.40039H19.3555V7.20083H20.1301V6.40039Z",
    fill: "#EDA507"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 6.40039H20.1289V7.20083H20.9035V6.40039Z",
    fill: "#FFCF00"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 6.40039H20.9043V7.20083H21.6789V6.40039Z",
    fill: "#FFCF00"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 6.40039H21.6777V7.20083H22.4523V6.40039Z",
    fill: "#FFCF00"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 6.40039H22.4512V7.20083H23.2258V6.40039Z",
    fill: "#EDA507"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 6.40039H23.2246V7.20083H23.9992V6.40039Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0.774601 7.20117H0V8.00161H0.774601V7.20117Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54999 7.20117H0.775391V8.00161H1.54999V7.20117Z",
    fill: "#F2F2F2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 7.20117H1.54883V8.00161H2.32343V7.20117Z",
    fill: "#F2F2F2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 7.20117H2.32227V8.00161H3.09687V7.20117Z",
    fill: "#F2F2F2"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 7.20117H3.0957V8.00161H3.8703V7.20117Z",
    fill: "#F2F2F2"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 7.20117H3.87109V8.00161H4.64569V7.20117Z",
    fill: "#F2F2F2"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 7.20117H4.64453V8.00161H5.41913V7.20117Z",
    fill: "#F2F2F2"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 7.20117H5.41992V8.00161H6.19452V7.20117Z",
    fill: "#F2F2F2"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 7.20117H6.19336V8.00161H6.96796V7.20117Z",
    fill: "#F2F2F2"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 7.20117H6.9668V8.00161H7.7414V7.20117Z",
    fill: "#F2F2F2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 7.20117H7.74219V8.00161H8.51679V7.20117Z",
    fill: "#F2F2F2"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 7.20117H8.51562V8.00161H9.29023V7.20117Z",
    fill: "#F2F2F2"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 7.20117H9.29102V8.00161H10.0656V7.20117Z",
    fill: "#F2F2F2"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 7.20117H10.0645V8.00161H10.8391V7.20117Z",
    fill: "#F2F2F2"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 7.20117H10.8398V8.00161H11.6144V7.20117Z",
    fill: "#F2F2F2"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 7.20117H11.6133V8.00161H12.3879V7.20117Z",
    fill: "#F2F2F2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 7.20117H12.3867V8.00161H13.1613V7.20117Z",
    fill: "#F2F2F2"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 7.20117H13.1602V8.00161H13.9348V7.20117Z",
    fill: "#F2F2F2"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 7.20117H13.9355V8.00161H14.7101V7.20117Z",
    fill: "#F2F2F2"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 7.20117H14.709V8.00161H15.4836V7.20117Z",
    fill: "#F2F2F2"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 7.20117H15.4844V8.00161H16.259V7.20117Z",
    fill: "#F2F2F2"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 7.20117H16.2578V8.00161H17.0324V7.20117Z",
    fill: "#F2F2F2"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 7.20117H17.0332V8.00161H17.8078V7.20117Z",
    fill: "#F2F2F2"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 7.20117H17.8066V8.00161H18.5812V7.20117Z",
    fill: "#F2F2F2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 7.20117H18.5801V8.00161H19.3547V7.20117Z",
    fill: "#F2F2F2"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 7.20117H19.3555V8.00161H20.1301V7.20117Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 7.20117H20.1289V8.00161H20.9035V7.20117Z",
    fill: "#EDA507"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 7.20117H20.9043V8.00161H21.6789V7.20117Z",
    fill: "#FFCF00"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 7.20117H21.6777V8.00161H22.4523V7.20117Z",
    fill: "#FFCF00"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 7.20117H22.4512V8.00161H23.2258V7.20117Z",
    fill: "#EDA507"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 7.20117H23.2246V8.00161H23.9992V7.20117Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0.774601 8H0V8.80044H0.774601V8Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54999 8H0.775391V8.80044H1.54999V8Z",
    fill: "#F2F2F2"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 8H1.54883V8.80044H2.32343V8Z",
    fill: "#FFCF00"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 8H2.32227V8.80044H3.09687V8Z",
    fill: "#FFCF00"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 8H3.0957V8.80044H3.8703V8Z",
    fill: "#FFCF00"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 8H3.87109V8.80044H4.64569V8Z",
    fill: "#FFCF00"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 8H4.64453V8.80044H5.41913V8Z",
    fill: "#FFCF00"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 8H5.41992V8.80044H6.19452V8Z",
    fill: "#FFCF00"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 8H6.19336V8.80044H6.96796V8Z",
    fill: "#FFCF00"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 8H6.9668V8.80044H7.7414V8Z",
    fill: "#FFCF00"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 8H7.74219V8.80044H8.51679V8Z",
    fill: "#FFCF00"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 8H8.51562V8.80044H9.29023V8Z",
    fill: "#FFCF00"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 8H9.29102V8.80044H10.0656V8Z",
    fill: "#FFCF00"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 8H10.0645V8.80044H10.8391V8Z",
    fill: "#FFCF00"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 8H10.8398V8.80044H11.6144V8Z",
    fill: "#FFCF00"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 8H11.6133V8.80044H12.3879V8Z",
    fill: "#FFCF00"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 8H12.3867V8.80044H13.1613V8Z",
    fill: "#FFCF00"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 8H13.1602V8.80044H13.9348V8Z",
    fill: "#FFCF00"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 8H13.9355V8.80044H14.7101V8Z",
    fill: "#FFCF00"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 8H14.709V8.80044H15.4836V8Z",
    fill: "#FFCF00"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 8H15.4844V8.80044H16.259V8Z",
    fill: "#FFCF00"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 8H16.2578V8.80044H17.0324V8Z",
    fill: "#FFCF00"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 8H17.0332V8.80044H17.8078V8Z",
    fill: "#FFCF00"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 8H17.8066V8.80044H18.5812V8Z",
    fill: "#FFCF00"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 8H18.5801V8.80044H19.3547V8Z",
    fill: "#FFCF00"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 8H19.3555V8.80044H20.1301V8Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 8H20.1289V8.80044H20.9035V8Z",
    fill: "#EDA507"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 8H20.9043V8.80044H21.6789V8Z",
    fill: "#FFCF00"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 8H21.6777V8.80044H22.4523V8Z",
    fill: "#FFCF00"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 8H22.4512V8.80044H23.2258V8Z",
    fill: "#EDA507"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 8H23.2246V8.80044H23.9992V8Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0.774601 8.80078H0V9.60122H0.774601V8.80078Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54999 8.80078H0.775391V9.60122H1.54999V8.80078Z",
    fill: "#F2F2F2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 8.80078H1.54883V9.60122H2.32343V8.80078Z",
    fill: "#FFCF00"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 8.80078H2.32227V9.60122H3.09687V8.80078Z",
    fill: "#FFCF00"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 8.80078H3.0957V9.60122H3.8703V8.80078Z",
    fill: "#FFCF00"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 8.80078H3.87109V9.60122H4.64569V8.80078Z",
    fill: "#FFCF00"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 8.80078H4.64453V9.60122H5.41913V8.80078Z",
    fill: "#FFCF00"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 8.80078H5.41992V9.60122H6.19452V8.80078Z",
    fill: "#FFCF00"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 8.80078H6.19336V9.60122H6.96796V8.80078Z",
    fill: "#FFCF00"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 8.80078H6.9668V9.60122H7.7414V8.80078Z",
    fill: "#FFCF00"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 8.80078H7.74219V9.60122H8.51679V8.80078Z",
    fill: "#FFCF00"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 8.80078H8.51562V9.60122H9.29023V8.80078Z",
    fill: "#FFCF00"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 8.80078H9.29102V9.60122H10.0656V8.80078Z",
    fill: "#FFCF00"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 8.80078H10.0645V9.60122H10.8391V8.80078Z",
    fill: "#FFCF00"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 8.80078H10.8398V9.60122H11.6144V8.80078Z",
    fill: "#FFCF00"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 8.80078H11.6133V9.60122H12.3879V8.80078Z",
    fill: "#FFCF00"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 8.80078H12.3867V9.60122H13.1613V8.80078Z",
    fill: "#FFCF00"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 8.80078H13.1602V9.60122H13.9348V8.80078Z",
    fill: "#FFCF00"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 8.80078H13.9355V9.60122H14.7101V8.80078Z",
    fill: "#FFCF00"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 8.80078H14.709V9.60122H15.4836V8.80078Z",
    fill: "#FFCF00"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 8.80078H15.4844V9.60122H16.259V8.80078Z",
    fill: "#FFCF00"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 8.80078H16.2578V9.60122H17.0324V8.80078Z",
    fill: "#FFCF00"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 8.80078H17.0332V9.60122H17.8078V8.80078Z",
    fill: "#FFCF00"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 8.80078H17.8066V9.60122H18.5812V8.80078Z",
    fill: "#FFCF00"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 8.80078H18.5801V9.60122H19.3547V8.80078Z",
    fill: "#FFCF00"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 8.80078H19.3555V9.60122H20.1301V8.80078Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 8.80078H20.1289V9.60122H20.9035V8.80078Z",
    fill: "#EDA507"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 8.80078H20.9043V9.60122H21.6789V8.80078Z",
    fill: "#FFCF00"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 8.80078H21.6777V9.60122H22.4523V8.80078Z",
    fill: "#FFCF00"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 8.80078H22.4512V9.60122H23.2258V8.80078Z",
    fill: "#EDA507"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 8.80078H23.2246V9.60122H23.9992V8.80078Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54999 9.59961H0.775391V10.4H1.54999V9.59961Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 9.59961H1.54883V10.4H2.32343V9.59961Z",
    fill: "#F2F2F2"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 9.59961H2.32227V10.4H3.09687V9.59961Z",
    fill: "#FFCF00"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 9.59961H3.0957V10.4H3.8703V9.59961Z",
    fill: "#FFCF00"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 9.59961H3.87109V10.4H4.64569V9.59961Z",
    fill: "#FFCF00"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 9.59961H4.64453V10.4H5.41913V9.59961Z",
    fill: "#FFCF00"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 9.59961H5.41992V10.4H6.19452V9.59961Z",
    fill: "#FFCF00"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 9.59961H6.19336V10.4H6.96796V9.59961Z",
    fill: "#FFCF00"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 9.59961H6.9668V10.4H7.7414V9.59961Z",
    fill: "#FFCF00"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 9.59961H7.74219V10.4H8.51679V9.59961Z",
    fill: "#FFCF00"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 9.59961H8.51562V10.4H9.29023V9.59961Z",
    fill: "#FFCF00"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 9.59961H9.29102V10.4H10.0656V9.59961Z",
    fill: "#FFCF00"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 9.59961H10.0645V10.4H10.8391V9.59961Z",
    fill: "#FFCF00"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 9.59961H10.8398V10.4H11.6144V9.59961Z",
    fill: "#FFCF00"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 9.59961H11.6133V10.4H12.3879V9.59961Z",
    fill: "#FFCF00"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 9.59961H12.3867V10.4H13.1613V9.59961Z",
    fill: "#FFCF00"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 9.59961H13.1602V10.4H13.9348V9.59961Z",
    fill: "#FFCF00"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 9.59961H13.9355V10.4H14.7101V9.59961Z",
    fill: "#FFCF00"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 9.59961H14.709V10.4H15.4836V9.59961Z",
    fill: "#FFCF00"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 9.59961H15.4844V10.4H16.259V9.59961Z",
    fill: "#FFCF00"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 9.59961H16.2578V10.4H17.0324V9.59961Z",
    fill: "#FFCF00"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 9.59961H17.0332V10.4H17.8078V9.59961Z",
    fill: "#FFCF00"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 9.59961H17.8066V10.4H18.5812V9.59961Z",
    fill: "#FFCF00"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 9.59961H18.5801V10.4H19.3547V9.59961Z",
    fill: "#FFCF00"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 9.59961H19.3555V10.4H20.1301V9.59961Z",
    fill: "#FFCF00"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 9.59961H20.1289V10.4H20.9035V9.59961Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 9.59961H20.9043V10.4H21.6789V9.59961Z",
    fill: "#EDA507"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 9.59961H21.6777V10.4H22.4523V9.59961Z",
    fill: "#FFCF00"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 9.59961H22.4512V10.4H23.2258V9.59961Z",
    fill: "#EDA507"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 9.59961H23.2246V10.4H23.9992V9.59961Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54999 10.4004H0.775391V11.2008H1.54999V10.4004Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 10.4004H1.54883V11.2008H2.32343V10.4004Z",
    fill: "#F2F2F2"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 10.4004H2.32227V11.2008H3.09687V10.4004Z",
    fill: "#FFCF00"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 10.4004H3.0957V11.2008H3.8703V10.4004Z",
    fill: "#FFCF00"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 10.4004H3.87109V11.2008H4.64569V10.4004Z",
    fill: "#FFCF00"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 10.4004H4.64453V11.2008H5.41913V10.4004Z",
    fill: "#FFCF00"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 10.4004H5.41992V11.2008H6.19452V10.4004Z",
    fill: "#FFCF00"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 10.4004H6.19336V11.2008H6.96796V10.4004Z",
    fill: "#FFCF00"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 10.4004H6.9668V11.2008H7.7414V10.4004Z",
    fill: "#FFCF00"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 10.4004H7.74219V11.2008H8.51679V10.4004Z",
    fill: "#FFCF00"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 10.4004H8.51562V11.2008H9.29023V10.4004Z",
    fill: "#FFCF00"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 10.4004H9.29102V11.2008H10.0656V10.4004Z",
    fill: "#FFCF00"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 10.4004H10.0645V11.2008H10.8391V10.4004Z",
    fill: "#FFCF00"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 10.4004H10.8398V11.2008H11.6144V10.4004Z",
    fill: "#FFCF00"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 10.4004H11.6133V11.2008H12.3879V10.4004Z",
    fill: "#FFCF00"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 10.4004H12.3867V11.2008H13.1613V10.4004Z",
    fill: "#FFCF00"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 10.4004H13.1602V11.2008H13.9348V10.4004Z",
    fill: "#FFCF00"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 10.4004H13.9355V11.2008H14.7101V10.4004Z",
    fill: "#FFCF00"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 10.4004H14.709V11.2008H15.4836V10.4004Z",
    fill: "#FFCF00"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 10.4004H15.4844V11.2008H16.259V10.4004Z",
    fill: "#FFCF00"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 10.4004H16.2578V11.2008H17.0324V10.4004Z",
    fill: "#FFCF00"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 10.4004H17.0332V11.2008H17.8078V10.4004Z",
    fill: "#FFCF00"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 10.4004H17.8066V11.2008H18.5812V10.4004Z",
    fill: "#FFCF00"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 10.4004H18.5801V11.2008H19.3547V10.4004Z",
    fill: "#FFCF00"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 10.4004H19.3555V11.2008H20.1301V10.4004Z",
    fill: "#FFCF00"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 10.4004H20.1289V11.2008H20.9035V10.4004Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 10.4004H20.9043V11.2008H21.6789V10.4004Z",
    fill: "#EDA507"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 10.4004H21.6777V11.2008H22.4523V10.4004Z",
    fill: "#FFCF00"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 10.4004H22.4512V11.2008H23.2258V10.4004Z",
    fill: "#EDA507"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 10.4004H23.2246V11.2008H23.9992V10.4004Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54999 11.2012H0.775391V12.0016H1.54999V11.2012Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 11.2012H1.54883V12.0016H2.32343V11.2012Z",
    fill: "#F2F2F2"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 11.2012H2.32227V12.0016H3.09687V11.2012Z",
    fill: "#FFCF00"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 11.2012H3.0957V12.0016H3.8703V11.2012Z",
    fill: "#FFCF00"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 11.2012H3.87109V12.0016H4.64569V11.2012Z",
    fill: "#FFCF00"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 11.2012H4.64453V12.0016H5.41913V11.2012Z",
    fill: "#FFCF00"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 11.2012H5.41992V12.0016H6.19452V11.2012Z",
    fill: "#FFCF00"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 11.2012H6.19336V12.0016H6.96796V11.2012Z",
    fill: "#FFCF00"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 11.2012H6.9668V12.0016H7.7414V11.2012Z",
    fill: "#FFCF00"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 11.2012H7.74219V12.0016H8.51679V11.2012Z",
    fill: "#FFCF00"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 11.2012H8.51562V12.0016H9.29023V11.2012Z",
    fill: "#FFCF00"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 11.2012H9.29102V12.0016H10.0656V11.2012Z",
    fill: "#FFCF00"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 11.2012H10.0645V12.0016H10.8391V11.2012Z",
    fill: "#FFCF00"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 11.2012H10.8398V12.0016H11.6144V11.2012Z",
    fill: "#FFCF00"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 11.2012H11.6133V12.0016H12.3879V11.2012Z",
    fill: "#FFCF00"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 11.2012H12.3867V12.0016H13.1613V11.2012Z",
    fill: "#FFCF00"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 11.2012H13.1602V12.0016H13.9348V11.2012Z",
    fill: "#FFCF00"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 11.2012H13.9355V12.0016H14.7101V11.2012Z",
    fill: "#FFCF00"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 11.2012H14.709V12.0016H15.4836V11.2012Z",
    fill: "#FFCF00"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 11.2012H15.4844V12.0016H16.259V11.2012Z",
    fill: "#FFCF00"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 11.2012H16.2578V12.0016H17.0324V11.2012Z",
    fill: "#FFCF00"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 11.2012H17.0332V12.0016H17.8078V11.2012Z",
    fill: "#FFCF00"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 11.2012H17.8066V12.0016H18.5812V11.2012Z",
    fill: "#FFCF00"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 11.2012H18.5801V12.0016H19.3547V11.2012Z",
    fill: "#FFCF00"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 11.2012H19.3555V12.0016H20.1301V11.2012Z",
    fill: "#FFCF00"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 11.2012H20.1289V12.0016H20.9035V11.2012Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 11.2012H20.9043V12.0016H21.6789V11.2012Z",
    fill: "#EDA507"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 11.2012H21.6777V12.0016H22.4523V11.2012Z",
    fill: "#FFCF00"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 11.2012H22.4512V12.0016H23.2258V11.2012Z",
    fill: "#EDA507"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 11.2012H23.2246V12.0016H23.9992V11.2012Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 12H1.54883V12.8004H2.32343V12Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 12H2.32227V12.8004H3.09687V12Z",
    fill: "#F2F2F2"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 12H3.0957V12.8004H3.8703V12Z",
    fill: "#FFCF00"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 12H3.87109V12.8004H4.64569V12Z",
    fill: "#FFCF00"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 12H4.64453V12.8004H5.41913V12Z",
    fill: "#FFCF00"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 12H5.41992V12.8004H6.19452V12Z",
    fill: "#FFCF00"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 12H6.19336V12.8004H6.96796V12Z",
    fill: "#FFCF00"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 12H6.9668V12.8004H7.7414V12Z",
    fill: "#FFCF00"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 12H7.74219V12.8004H8.51679V12Z",
    fill: "#FFCF00"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 12H8.51562V12.8004H9.29023V12Z",
    fill: "#FFCF00"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 12H9.29102V12.8004H10.0656V12Z",
    fill: "#FFCF00"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 12H10.0645V12.8004H10.8391V12Z",
    fill: "#FFCF00"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 12H10.8398V12.8004H11.6144V12Z",
    fill: "#FFCF00"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 12H11.6133V12.8004H12.3879V12Z",
    fill: "#FFCF00"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 12H12.3867V12.8004H13.1613V12Z",
    fill: "#FFCF00"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 12H13.1602V12.8004H13.9348V12Z",
    fill: "#FFCF00"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 12H13.9355V12.8004H14.7101V12Z",
    fill: "#FFCF00"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 12H14.709V12.8004H15.4836V12Z",
    fill: "#FFCF00"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 12H15.4844V12.8004H16.259V12Z",
    fill: "#FFCF00"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 12H16.2578V12.8004H17.0324V12Z",
    fill: "#FFCF00"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 12H17.0332V12.8004H17.8078V12Z",
    fill: "#FFCF00"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 12H17.8066V12.8004H18.5812V12Z",
    fill: "#FFCF00"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 12H18.5801V12.8004H19.3547V12Z",
    fill: "#FFCF00"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 12H19.3555V12.8004H20.1301V12Z",
    fill: "#FFCF00"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 12H20.1289V12.8004H20.9035V12Z",
    fill: "#FFCF00"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 12H20.9043V12.8004H21.6789V12Z",
    fill: "black"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 12H21.6777V12.8004H22.4523V12Z",
    fill: "#EDA507"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 12H22.4512V12.8004H23.2258V12Z",
    fill: "#EDA507"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 12H23.2246V12.8004H23.9992V12Z",
    fill: "black"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 12.8008H1.54883V13.6012H2.32343V12.8008Z",
    fill: "black"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 12.8008H2.32227V13.6012H3.09687V12.8008Z",
    fill: "#F2F2F2"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 12.8008H3.0957V13.6012H3.8703V12.8008Z",
    fill: "#FFCF00"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 12.8008H3.87109V13.6012H4.64569V12.8008Z",
    fill: "#FFCF00"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 12.8008H4.64453V13.6012H5.41913V12.8008Z",
    fill: "#FFCF00"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 12.8008H5.41992V13.6012H6.19452V12.8008Z",
    fill: "#FFCF00"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 12.8008H6.19336V13.6012H6.96796V12.8008Z",
    fill: "#FFCF00"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 12.8008H6.9668V13.6012H7.7414V12.8008Z",
    fill: "#FFCF00"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 12.8008H7.74219V13.6012H8.51679V12.8008Z",
    fill: "#FFCF00"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 12.8008H8.51562V13.6012H9.29023V12.8008Z",
    fill: "#FFCF00"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 12.8008H9.29102V13.6012H10.0656V12.8008Z",
    fill: "#FFCF00"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 12.8008H10.0645V13.6012H10.8391V12.8008Z",
    fill: "#FFCF00"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 12.8008H10.8398V13.6012H11.6144V12.8008Z",
    fill: "#FFCF00"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 12.8008H11.6133V13.6012H12.3879V12.8008Z",
    fill: "#FFCF00"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 12.8008H12.3867V13.6012H13.1613V12.8008Z",
    fill: "#FFCF00"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 12.8008H13.1602V13.6012H13.9348V12.8008Z",
    fill: "#FFCF00"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 12.8008H13.9355V13.6012H14.7101V12.8008Z",
    fill: "#FFCF00"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 12.8008H14.709V13.6012H15.4836V12.8008Z",
    fill: "#FFCF00"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 12.8008H15.4844V13.6012H16.259V12.8008Z",
    fill: "#FFCF00"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 12.8008H16.2578V13.6012H17.0324V12.8008Z",
    fill: "#FFCF00"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 12.8008H17.0332V13.6012H17.8078V12.8008Z",
    fill: "#FFCF00"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 12.8008H17.8066V13.6012H18.5812V12.8008Z",
    fill: "#FFCF00"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 12.8008H18.5801V13.6012H19.3547V12.8008Z",
    fill: "#FFCF00"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 12.8008H19.3555V13.6012H20.1301V12.8008Z",
    fill: "#FFCF00"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 12.8008H20.1289V13.6012H20.9035V12.8008Z",
    fill: "#FFCF00"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 12.8008H20.9043V13.6012H21.6789V12.8008Z",
    fill: "black"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 12.8008H21.6777V13.6012H22.4523V12.8008Z",
    fill: "#EDA507"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 12.8008H22.4512V13.6012H23.2258V12.8008Z",
    fill: "#EDA507"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 12.8008H23.2246V13.6012H23.9992V12.8008Z",
    fill: "black"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32343 13.5996H1.54883V14.4H2.32343V13.5996Z",
    fill: "black"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 13.5996H2.32227V14.4H3.09687V13.5996Z",
    fill: "#F2F2F2"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 13.5996H3.0957V14.4H3.8703V13.5996Z",
    fill: "#FFCF00"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 13.5996H3.87109V14.4H4.64569V13.5996Z",
    fill: "#FFCF00"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 13.5996H4.64453V14.4H5.41913V13.5996Z",
    fill: "#FFCF00"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 13.5996H5.41992V14.4H6.19452V13.5996Z",
    fill: "#FFCF00"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 13.5996H6.19336V14.4H6.96796V13.5996Z",
    fill: "#FFCF00"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 13.5996H6.9668V14.4H7.7414V13.5996Z",
    fill: "#FFCF00"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 13.5996H7.74219V14.4H8.51679V13.5996Z",
    fill: "#FFCF00"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 13.5996H8.51562V14.4H9.29023V13.5996Z",
    fill: "#FFCF00"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 13.5996H9.29102V14.4H10.0656V13.5996Z",
    fill: "#FFCF00"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 13.5996H10.0645V14.4H10.8391V13.5996Z",
    fill: "#FFCF00"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 13.5996H10.8398V14.4H11.6144V13.5996Z",
    fill: "#FFCF00"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 13.5996H11.6133V14.4H12.3879V13.5996Z",
    fill: "#FFCF00"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 13.5996H12.3867V14.4H13.1613V13.5996Z",
    fill: "#FFCF00"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 13.5996H13.1602V14.4H13.9348V13.5996Z",
    fill: "#FFCF00"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 13.5996H13.9355V14.4H14.7101V13.5996Z",
    fill: "#FFCF00"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 13.5996H14.709V14.4H15.4836V13.5996Z",
    fill: "#FFCF00"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 13.5996H15.4844V14.4H16.259V13.5996Z",
    fill: "#FFCF00"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 13.5996H16.2578V14.4H17.0324V13.5996Z",
    fill: "#FFCF00"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 13.5996H17.0332V14.4H17.8078V13.5996Z",
    fill: "#FFCF00"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 13.5996H17.8066V14.4H18.5812V13.5996Z",
    fill: "#FFCF00"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 13.5996H18.5801V14.4H19.3547V13.5996Z",
    fill: "#FFCF00"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 13.5996H19.3555V14.4H20.1301V13.5996Z",
    fill: "#FFCF00"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 13.5996H20.1289V14.4H20.9035V13.5996Z",
    fill: "#FFCF00"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 13.5996H20.9043V14.4H21.6789V13.5996Z",
    fill: "black"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 13.5996H21.6777V14.4H22.4523V13.5996Z",
    fill: "#EDA507"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 13.5996H22.4512V14.4H23.2258V13.5996Z",
    fill: "#EDA507"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 13.5996H23.2246V14.4H23.9992V13.5996Z",
    fill: "black"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 14.4004H2.32227V15.2008H3.09687V14.4004Z",
    fill: "black"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 14.4004H3.0957V15.2008H3.8703V14.4004Z",
    fill: "#F2F2F2"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 14.4004H3.87109V15.2008H4.64569V14.4004Z",
    fill: "#FFCF00"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 14.4004H4.64453V15.2008H5.41913V14.4004Z",
    fill: "#FFCF00"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 14.4004H5.41992V15.2008H6.19452V14.4004Z",
    fill: "#FFCF00"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 14.4004H6.19336V15.2008H6.96796V14.4004Z",
    fill: "#FFCF00"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 14.4004H6.9668V15.2008H7.7414V14.4004Z",
    fill: "#FFCF00"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 14.4004H7.74219V15.2008H8.51679V14.4004Z",
    fill: "#FFCF00"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 14.4004H8.51562V15.2008H9.29023V14.4004Z",
    fill: "#FFCF00"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 14.4004H9.29102V15.2008H10.0656V14.4004Z",
    fill: "#FFCF00"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 14.4004H10.0645V15.2008H10.8391V14.4004Z",
    fill: "#FFCF00"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 14.4004H10.8398V15.2008H11.6144V14.4004Z",
    fill: "#FFCF00"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 14.4004H11.6133V15.2008H12.3879V14.4004Z",
    fill: "#FFCF00"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 14.4004H12.3867V15.2008H13.1613V14.4004Z",
    fill: "#FFCF00"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 14.4004H13.1602V15.2008H13.9348V14.4004Z",
    fill: "#FFCF00"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 14.4004H13.9355V15.2008H14.7101V14.4004Z",
    fill: "#FFCF00"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 14.4004H14.709V15.2008H15.4836V14.4004Z",
    fill: "#FFCF00"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 14.4004H15.4844V15.2008H16.259V14.4004Z",
    fill: "#FFCF00"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 14.4004H16.2578V15.2008H17.0324V14.4004Z",
    fill: "#FFCF00"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 14.4004H17.0332V15.2008H17.8078V14.4004Z",
    fill: "#FFCF00"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 14.4004H17.8066V15.2008H18.5812V14.4004Z",
    fill: "#FFCF00"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 14.4004H18.5801V15.2008H19.3547V14.4004Z",
    fill: "#FFCF00"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 14.4004H19.3555V15.2008H20.1301V14.4004Z",
    fill: "#FFCF00"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 14.4004H20.1289V15.2008H20.9035V14.4004Z",
    fill: "#FFCF00"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 14.4004H20.9043V15.2008H21.6789V14.4004Z",
    fill: "#FFCF00"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 14.4004H21.6777V15.2008H22.4523V14.4004Z",
    fill: "black"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 14.4004H22.4512V15.2008H23.2258V14.4004Z",
    fill: "#EDA507"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 14.4004H23.2246V15.2008H23.9992V14.4004Z",
    fill: "black"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 15.2012H2.32227V16.0016H3.09687V15.2012Z",
    fill: "black"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 15.2012H3.0957V16.0016H3.8703V15.2012Z",
    fill: "#F2F2F2"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 15.2012H3.87109V16.0016H4.64569V15.2012Z",
    fill: "#FFCF00"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 15.2012H4.64453V16.0016H5.41913V15.2012Z",
    fill: "#FFCF00"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 15.2012H5.41992V16.0016H6.19452V15.2012Z",
    fill: "#FFCF00"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 15.2012H6.19336V16.0016H6.96796V15.2012Z",
    fill: "#FFCF00"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 15.2012H6.9668V16.0016H7.7414V15.2012Z",
    fill: "#FFCF00"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 15.2012H7.74219V16.0016H8.51679V15.2012Z",
    fill: "#FFCF00"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 15.2012H8.51562V16.0016H9.29023V15.2012Z",
    fill: "#FFCF00"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 15.2012H9.29102V16.0016H10.0656V15.2012Z",
    fill: "#FFCF00"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 15.2012H10.0645V16.0016H10.8391V15.2012Z",
    fill: "#FFCF00"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 15.2012H10.8398V16.0016H11.6144V15.2012Z",
    fill: "#FFCF00"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 15.2012H11.6133V16.0016H12.3879V15.2012Z",
    fill: "#FFCF00"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 15.2012H12.3867V16.0016H13.1613V15.2012Z",
    fill: "#FFCF00"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 15.2012H13.1602V16.0016H13.9348V15.2012Z",
    fill: "#FFCF00"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 15.2012H13.9355V16.0016H14.7101V15.2012Z",
    fill: "#FFCF00"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 15.2012H14.709V16.0016H15.4836V15.2012Z",
    fill: "#FFCF00"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 15.2012H15.4844V16.0016H16.259V15.2012Z",
    fill: "#FFCF00"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 15.2012H16.2578V16.0016H17.0324V15.2012Z",
    fill: "#FFCF00"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 15.2012H17.0332V16.0016H17.8078V15.2012Z",
    fill: "#FFCF00"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 15.2012H17.8066V16.0016H18.5812V15.2012Z",
    fill: "#FFCF00"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 15.2012H18.5801V16.0016H19.3547V15.2012Z",
    fill: "#FFCF00"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 15.2012H19.3555V16.0016H20.1301V15.2012Z",
    fill: "#FFCF00"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 15.2012H20.1289V16.0016H20.9035V15.2012Z",
    fill: "#FFCF00"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 15.2012H20.9043V16.0016H21.6789V15.2012Z",
    fill: "#FFCF00"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 15.2012H21.6777V16.0016H22.4523V15.2012Z",
    fill: "black"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 15.2012H22.4512V16.0016H23.2258V15.2012Z",
    fill: "#EDA507"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 15.2012H23.2246V16.0016H23.9992V15.2012Z",
    fill: "black"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09687 16H2.32227V16.8004H3.09687V16Z",
    fill: "black"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 16H3.0957V16.8004H3.8703V16Z",
    fill: "#F2F2F2"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 16H3.87109V16.8004H4.64569V16Z",
    fill: "#FFCF00"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 16H4.64453V16.8004H5.41913V16Z",
    fill: "#FFCF00"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 16H5.41992V16.8004H6.19452V16Z",
    fill: "#FFCF00"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 16H6.19336V16.8004H6.96796V16Z",
    fill: "#FFCF00"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 16H6.9668V16.8004H7.7414V16Z",
    fill: "#FFCF00"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 16H7.74219V16.8004H8.51679V16Z",
    fill: "#FFCF00"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 16H8.51562V16.8004H9.29023V16Z",
    fill: "#FFCF00"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 16H9.29102V16.8004H10.0656V16Z",
    fill: "#FFCF00"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 16H10.0645V16.8004H10.8391V16Z",
    fill: "#FFCF00"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 16H10.8398V16.8004H11.6144V16Z",
    fill: "#FFCF00"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 16H11.6133V16.8004H12.3879V16Z",
    fill: "#FFCF00"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 16H12.3867V16.8004H13.1613V16Z",
    fill: "#FFCF00"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 16H13.1602V16.8004H13.9348V16Z",
    fill: "#FFCF00"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 16H13.9355V16.8004H14.7101V16Z",
    fill: "#FFCF00"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 16H14.709V16.8004H15.4836V16Z",
    fill: "#FFCF00"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 16H15.4844V16.8004H16.259V16Z",
    fill: "#FFCF00"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 16H16.2578V16.8004H17.0324V16Z",
    fill: "#FFCF00"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 16H17.0332V16.8004H17.8078V16Z",
    fill: "#FFCF00"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 16H17.8066V16.8004H18.5812V16Z",
    fill: "#FFCF00"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 16H18.5801V16.8004H19.3547V16Z",
    fill: "#FFCF00"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 16H19.3555V16.8004H20.1301V16Z",
    fill: "#FFCF00"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 16H20.1289V16.8004H20.9035V16Z",
    fill: "#FFCF00"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 16H20.9043V16.8004H21.6789V16Z",
    fill: "#FFCF00"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 16H21.6777V16.8004H22.4523V16Z",
    fill: "black"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 16H22.4512V16.8004H23.2258V16Z",
    fill: "#EDA507"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 16H23.2246V16.8004H23.9992V16Z",
    fill: "black"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 16.8008H3.0957V17.6012H3.8703V16.8008Z",
    fill: "black"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 16.8008H3.87109V17.6012H4.64569V16.8008Z",
    fill: "#F2F2F2"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 16.8008H4.64453V17.6012H5.41913V16.8008Z",
    fill: "#FFCF00"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 16.8008H5.41992V17.6012H6.19452V16.8008Z",
    fill: "#FFCF00"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 16.8008H6.19336V17.6012H6.96796V16.8008Z",
    fill: "#FFCF00"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 16.8008H6.9668V17.6012H7.7414V16.8008Z",
    fill: "#FFCF00"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 16.8008H7.74219V17.6012H8.51679V16.8008Z",
    fill: "#FFCF00"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 16.8008H8.51562V17.6012H9.29023V16.8008Z",
    fill: "#FFCF00"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 16.8008H9.29102V17.6012H10.0656V16.8008Z",
    fill: "#FFCF00"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 16.8008H10.0645V17.6012H10.8391V16.8008Z",
    fill: "#FFCF00"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 16.8008H10.8398V17.6012H11.6144V16.8008Z",
    fill: "#FFCF00"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 16.8008H11.6133V17.6012H12.3879V16.8008Z",
    fill: "#FFCF00"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 16.8008H12.3867V17.6012H13.1613V16.8008Z",
    fill: "#FFCF00"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 16.8008H13.1602V17.6012H13.9348V16.8008Z",
    fill: "#FFCF00"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 16.8008H13.9355V17.6012H14.7101V16.8008Z",
    fill: "#FFCF00"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 16.8008H14.709V17.6012H15.4836V16.8008Z",
    fill: "#FFCF00"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 16.8008H15.4844V17.6012H16.259V16.8008Z",
    fill: "#FFCF00"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 16.8008H16.2578V17.6012H17.0324V16.8008Z",
    fill: "#FFCF00"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 16.8008H17.0332V17.6012H17.8078V16.8008Z",
    fill: "#FFCF00"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 16.8008H17.8066V17.6012H18.5812V16.8008Z",
    fill: "#FFCF00"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 16.8008H18.5801V17.6012H19.3547V16.8008Z",
    fill: "#FFCF00"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 16.8008H19.3555V17.6012H20.1301V16.8008Z",
    fill: "#FFCF00"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 16.8008H20.1289V17.6012H20.9035V16.8008Z",
    fill: "#FFCF00"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 16.8008H20.9043V17.6012H21.6789V16.8008Z",
    fill: "#FFCF00"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 16.8008H21.6777V17.6012H22.4523V16.8008Z",
    fill: "#FFCF00"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 16.8008H22.4512V17.6012H23.2258V16.8008Z",
    fill: "black"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 16.8008H23.2246V17.6012H23.9992V16.8008Z",
    fill: "black"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 17.6016H3.0957V18.402H3.8703V17.6016Z",
    fill: "black"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 17.6016H3.87109V18.402H4.64569V17.6016Z",
    fill: "#F2F2F2"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 17.6016H4.64453V18.402H5.41913V17.6016Z",
    fill: "#FFCF00"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 17.6016H5.41992V18.402H6.19452V17.6016Z",
    fill: "#FFCF00"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 17.6016H6.19336V18.402H6.96796V17.6016Z",
    fill: "#FFCF00"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 17.6016H6.9668V18.402H7.7414V17.6016Z",
    fill: "#FFCF00"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 17.6016H7.74219V18.402H8.51679V17.6016Z",
    fill: "#FFCF00"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 17.6016H8.51562V18.402H9.29023V17.6016Z",
    fill: "#FFCF00"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 17.6016H9.29102V18.402H10.0656V17.6016Z",
    fill: "#FFCF00"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 17.6016H10.0645V18.402H10.8391V17.6016Z",
    fill: "#FFCF00"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 17.6016H10.8398V18.402H11.6144V17.6016Z",
    fill: "#FFCF00"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 17.6016H11.6133V18.402H12.3879V17.6016Z",
    fill: "#FFCF00"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 17.6016H12.3867V18.402H13.1613V17.6016Z",
    fill: "#FFCF00"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 17.6016H13.1602V18.402H13.9348V17.6016Z",
    fill: "#FFCF00"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 17.6016H13.9355V18.402H14.7101V17.6016Z",
    fill: "#FFCF00"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 17.6016H14.709V18.402H15.4836V17.6016Z",
    fill: "#FFCF00"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 17.6016H15.4844V18.402H16.259V17.6016Z",
    fill: "#FFCF00"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 17.6016H16.2578V18.402H17.0324V17.6016Z",
    fill: "#FFCF00"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 17.6016H17.0332V18.402H17.8078V17.6016Z",
    fill: "#FFCF00"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 17.6016H17.8066V18.402H18.5812V17.6016Z",
    fill: "#FFCF00"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 17.6016H18.5801V18.402H19.3547V17.6016Z",
    fill: "#FFCF00"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 17.6016H19.3555V18.402H20.1301V17.6016Z",
    fill: "#FFCF00"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 17.6016H20.1289V18.402H20.9035V17.6016Z",
    fill: "#FFCF00"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 17.6016H20.9043V18.402H21.6789V17.6016Z",
    fill: "#FFCF00"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 17.6016H21.6777V18.402H22.4523V17.6016Z",
    fill: "#FFCF00"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 17.6016H22.4512V18.402H23.2258V17.6016Z",
    fill: "black"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 17.6016H23.2246V18.402H23.9992V17.6016Z",
    fill: "black"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8703 18.4004H3.0957V19.2008H3.8703V18.4004Z",
    fill: "black"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 18.4004H3.87109V19.2008H4.64569V18.4004Z",
    fill: "#EDA507"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 18.4004H4.64453V19.2008H5.41913V18.4004Z",
    fill: "#EDA507"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 18.4004H5.41992V19.2008H6.19452V18.4004Z",
    fill: "#EDA507"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 18.4004H6.19336V19.2008H6.96796V18.4004Z",
    fill: "#EDA507"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 18.4004H6.9668V19.2008H7.7414V18.4004Z",
    fill: "#EDA507"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 18.4004H7.74219V19.2008H8.51679V18.4004Z",
    fill: "#EDA507"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 18.4004H8.51562V19.2008H9.29023V18.4004Z",
    fill: "#EDA507"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 18.4004H9.29102V19.2008H10.0656V18.4004Z",
    fill: "#EDA507"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 18.4004H10.0645V19.2008H10.8391V18.4004Z",
    fill: "#EDA507"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 18.4004H10.8398V19.2008H11.6144V18.4004Z",
    fill: "#EDA507"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 18.4004H11.6133V19.2008H12.3879V18.4004Z",
    fill: "#EDA507"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 18.4004H12.3867V19.2008H13.1613V18.4004Z",
    fill: "#EDA507"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 18.4004H13.1602V19.2008H13.9348V18.4004Z",
    fill: "#EDA507"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 18.4004H13.9355V19.2008H14.7101V18.4004Z",
    fill: "#EDA507"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 18.4004H14.709V19.2008H15.4836V18.4004Z",
    fill: "#EDA507"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 18.4004H15.4844V19.2008H16.259V18.4004Z",
    fill: "#EDA507"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 18.4004H16.2578V19.2008H17.0324V18.4004Z",
    fill: "#EDA507"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 18.4004H17.0332V19.2008H17.8078V18.4004Z",
    fill: "#EDA507"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 18.4004H17.8066V19.2008H18.5812V18.4004Z",
    fill: "#EDA507"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 18.4004H18.5801V19.2008H19.3547V18.4004Z",
    fill: "#EDA507"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 18.4004H19.3555V19.2008H20.1301V18.4004Z",
    fill: "#EDA507"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 18.4004H20.1289V19.2008H20.9035V18.4004Z",
    fill: "#EDA507"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 18.4004H20.9043V19.2008H21.6789V18.4004Z",
    fill: "#EDA507"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 18.4004H21.6777V19.2008H22.4523V18.4004Z",
    fill: "#EDA507"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 18.4004H22.4512V19.2008H23.2258V18.4004Z",
    fill: "black"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 18.4004H23.2246V19.2008H23.9992V18.4004Z",
    fill: "black"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64569 19.2012H3.87109V20.0016H4.64569V19.2012Z",
    fill: "black"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41913 19.2012H4.64453V20.0016H5.41913V19.2012Z",
    fill: "black"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19452 19.2012H5.41992V20.0016H6.19452V19.2012Z",
    fill: "black"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96796 19.2012H6.19336V20.0016H6.96796V19.2012Z",
    fill: "black"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7414 19.2012H6.9668V20.0016H7.7414V19.2012Z",
    fill: "black"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51679 19.2012H7.74219V20.0016H8.51679V19.2012Z",
    fill: "black"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29023 19.2012H8.51562V20.0016H9.29023V19.2012Z",
    fill: "black"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 19.2012H9.29102V20.0016H10.0656V19.2012Z",
    fill: "black"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 19.2012H10.0645V20.0016H10.8391V19.2012Z",
    fill: "black"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6144 19.2012H10.8398V20.0016H11.6144V19.2012Z",
    fill: "black"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 19.2012H11.6133V20.0016H12.3879V19.2012Z",
    fill: "black"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 19.2012H12.3867V20.0016H13.1613V19.2012Z",
    fill: "black"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 19.2012H13.1602V20.0016H13.9348V19.2012Z",
    fill: "black"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 19.2012H13.9355V20.0016H14.7101V19.2012Z",
    fill: "black"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4836 19.2012H14.709V20.0016H15.4836V19.2012Z",
    fill: "black"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 19.2012H15.4844V20.0016H16.259V19.2012Z",
    fill: "black"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0324 19.2012H16.2578V20.0016H17.0324V19.2012Z",
    fill: "black"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 19.2012H17.0332V20.0016H17.8078V19.2012Z",
    fill: "black"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 19.2012H17.8066V20.0016H18.5812V19.2012Z",
    fill: "black"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3547 19.2012H18.5801V20.0016H19.3547V19.2012Z",
    fill: "black"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 19.2012H19.3555V20.0016H20.1301V19.2012Z",
    fill: "black"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 19.2012H20.1289V20.0016H20.9035V19.2012Z",
    fill: "black"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6789 19.2012H20.9043V20.0016H21.6789V19.2012Z",
    fill: "black"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4523 19.2012H21.6777V20.0016H22.4523V19.2012Z",
    fill: "black"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 19.2012H22.4512V20.0016H23.2258V19.2012Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 0H5.41943V0.800435H6.19403V0Z",
    fill: "#181425"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 0H6.19403V0.800435H6.9682V0Z",
    fill: "#181425"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 0H6.96704V0.800435H7.74164V0Z",
    fill: "#181425"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 0H7.74164V0.800435H8.5163V0Z",
    fill: "#181425"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 0H8.5163V0.800435H9.29071V0Z",
    fill: "#181425"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 0H9.29071V0.800435H10.0649V0Z",
    fill: "#181425"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 0H10.0649V0.800435H10.8391V0Z",
    fill: "#181425"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41943 0.800435L4.64526 0.800293V1.60073H5.41986L5.41943 0.800435Z",
    fill: "#181425"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 0.800435H5.41943L5.41986 1.60073H6.19403V0.800435Z",
    fill: "#181425"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 0.800435H6.19403V1.60073L6.9682 1.60097V0.800435Z",
    fill: "#181425"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 0.800435H6.96704V1.60073H7.74164V0.800435Z",
    fill: "#181425"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 0.800435H7.74164V1.60073L8.5163 1.60097V0.800435Z",
    fill: "#181425"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 0.800435H8.5163V1.60097L9.29071 1.60073V0.800435Z",
    fill: "#181425"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 0.800435H9.29071V1.60073H10.0649V0.800435Z",
    fill: "#181425"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 0.800435H10.0649V1.60073L10.8391 1.60097V0.800435Z",
    fill: "#181425"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 0.800293L10.8391 0.800435V1.60097L11.614 1.60073V0.800293Z",
    fill: "#181425"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64526 1.60073L3.87085 1.59985V2.40029H4.64545L4.64526 1.60073Z",
    fill: "#181425"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 1.60073H4.64526L4.64545 2.40029H5.41986V1.60073Z",
    fill: "#181425"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 1.60073H5.41986V2.40029H6.19403V1.60073Z",
    fill: "#181425"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 1.59985L6.19403 1.60073V2.40029H6.9682V1.59985Z",
    fill: "#181425"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 1.60073H6.96704V2.40029H7.74164V1.60073Z",
    fill: "#181425"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 1.59985L7.74164 1.60073V2.40029H8.5163V1.59985Z",
    fill: "#181425"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 1.60073L8.5163 1.59985V2.40029H9.29071V1.60073Z",
    fill: "#181425"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 1.60073H9.29071V2.40029H10.0649V1.60073Z",
    fill: "#181425"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 1.59985L10.0649 1.60073V2.40029H10.8391V1.59985Z",
    fill: "#181425"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 1.60073L10.8391 1.59985V2.40029H11.614V1.60073Z",
    fill: "#181425"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 1.59985H11.6128V2.40029H12.3874V1.59985Z",
    fill: "#181425"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87085 2.40029L3.09595 2.40015V3.20058H3.87055L3.87085 2.40029Z",
    fill: "#181425"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 2.40029H3.87085L3.87055 3.20058H4.64545V2.40029Z",
    fill: "#181425"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 2.40029H4.64545V3.20058H5.41986V2.40029Z",
    fill: "#181425"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 2.40029H5.41986V3.20058H6.19403V2.40029Z",
    fill: "#181425"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 2.40029H6.19403V3.20058H6.9682V2.40029Z",
    fill: "#181425"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 2.40029H6.96704V3.20058H7.74164V2.40029Z",
    fill: "#181425"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 2.40029H7.74164V3.20058H8.5163V2.40029Z",
    fill: "#181425"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 2.40029H8.5163V3.20058H9.29071V2.40029Z",
    fill: "#181425"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 2.40029H9.29071V3.20058H10.0649V2.40029Z",
    fill: "#181425"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 2.40029H10.0649V3.20058H10.8391V2.40029Z",
    fill: "#181425"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 2.40029H10.8391V3.20058H11.614V2.40029Z",
    fill: "#181425"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 2.40029H11.6128V3.20058H12.3874V2.40029Z",
    fill: "#181425"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 2.40015L12.3874 2.40029V3.20058H13.1618V2.40015Z",
    fill: "#181425"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 2.40015H13.1606V3.20058H13.9352V2.40015Z",
    fill: "#181425"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 2.40015H13.9352V3.20058H14.7101V2.40015Z",
    fill: "#181425"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 2.40015H14.7101V3.20058H15.4843V2.40015Z",
    fill: "#181425"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 2.40015H15.4843V3.20058H16.2585V2.40015Z",
    fill: "#181425"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 2.40015H16.2585V3.20058H17.0329V2.40015Z",
    fill: "#181425"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 2.40015H17.0329V3.20058H17.8076V2.40015Z",
    fill: "#181425"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 2.40015H17.8064V3.20058H18.581V2.40015Z",
    fill: "#181425"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 2.40015H18.581V3.20058H19.3552V2.40015Z",
    fill: "#181425"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 2.40015H19.3552V3.20058H20.1293V2.40015Z",
    fill: "#181425"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 2.40015H20.1293V3.20058H20.9038V2.40015Z",
    fill: "#181425"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 2.40015H20.9038V3.20058H21.6787V2.40015Z",
    fill: "#181425"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 2.40015H21.6772V3.20058H22.4518V2.40015Z",
    fill: "#181425"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 3.20058H3.09595V4.00014H3.87055V3.20058Z",
    fill: "#181425"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 3.20058H3.87055V4.00014H4.64545V3.20058Z",
    fill: "#181425"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 3.20058H4.64545V4.00014H5.41986V3.20058Z",
    fill: "#181425"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 3.20058H5.41986V4.00014H6.19403V3.20058Z",
    fill: "#181425"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 3.20058H6.19403V4.00014H6.9682V3.20058Z",
    fill: "#181425"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 3.20058H6.96704V4.00014H7.74164V3.20058Z",
    fill: "#181425"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 3.20058H7.74164V4.00014H8.5163V3.20058Z",
    fill: "#181425"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 3.20058H8.5163V4.00014H9.29071V3.20058Z",
    fill: "#181425"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 3.20058H9.29071V4.00014H10.0649V3.20058Z",
    fill: "#181425"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 3.19946H10.0645L10.0649 4.00014L10.8391 3.9999V3.19946Z",
    fill: "#181425"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 3.20058H10.8391V3.9999L11.614 4.00014V3.20058Z",
    fill: "#181425"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 3.20058H11.6128V4.00014H12.3874V3.20058Z",
    fill: "#181425"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 3.20058H12.3874V4.00014H13.1618V3.20058Z",
    fill: "#181425"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 3.20058H13.1606V4.00014H13.9352V3.20058Z",
    fill: "#181425"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 3.19946H13.9355L13.9352 4.00014L14.7101 3.9999V3.19946Z",
    fill: "#181425"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 3.20058L14.7101 3.19946V3.9999L15.4843 4.00014V3.20058Z",
    fill: "#181425"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 3.20058H15.4843V4.00014H16.2585V3.20058Z",
    fill: "#181425"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 3.20058H16.2585V4.00014H17.0329V3.20058Z",
    fill: "#181425"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 3.20058H17.0329V4.00014H17.8076V3.20058Z",
    fill: "#181425"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 3.20058H17.8064V4.00014H18.581V3.20058Z",
    fill: "#181425"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 3.20058H18.581V4.00014H19.3552V3.20058Z",
    fill: "#181425"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 3.20058H19.3552V4.00014H20.1293V3.20058Z",
    fill: "#181425"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 3.20058H20.1293V4.00014H20.9038V3.20058Z",
    fill: "#181425"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 3.20058H20.9038V4.00014H21.6787V3.20058Z",
    fill: "#181425"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 3.20058H21.6772V4.00014H22.4518V3.20058Z",
    fill: "#181425"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 3.19971L22.4518 3.20058V4.00014H23.2263V3.19971Z",
    fill: "#181425"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 4.00014H3.09595V4.80044H3.87055V4.00014Z",
    fill: "#181425"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 4.00014H3.87055V4.80044H4.64545V4.00014Z",
    fill: "#181425"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 4.00014H4.64545V4.80044H5.41986V4.00014Z",
    fill: "#181425"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 4.00014H5.41986V4.80044H6.19403V4.00014Z",
    fill: "#181425"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 4.00014H6.19403V4.80044H6.9682V4.00014Z",
    fill: "#181425"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 4.00014H6.96704V4.80044H7.74164V4.00014Z",
    fill: "#181425"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 4.00014H7.74164V4.80044H8.5163V4.00014Z",
    fill: "#181425"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 4.00014H8.5163V4.80044H9.29071V4.00014Z",
    fill: "#181425"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 4.00014H9.29071V4.80044H10.0649V4.00014Z",
    fill: "#181425"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 3.9999L10.0649 4.00014V4.80044H10.8391V3.9999Z",
    fill: "#181425"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 4.00014L10.8391 3.9999V4.80044H11.614V4.00014Z",
    fill: "#181425"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 4.00014H11.6128V4.80044H12.3874V4.00014Z",
    fill: "#181425"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 4.00014H12.3874V4.80044H13.1618V4.00014Z",
    fill: "#181425"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 4.00014H13.1606V4.80044H13.9352V4.00014Z",
    fill: "#181425"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 3.9999L13.9352 4.00014V4.80044H14.7101V3.9999Z",
    fill: "#181425"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 4.00014L14.7101 3.9999V4.80044H15.4843V4.00014Z",
    fill: "#181425"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 4.00014H15.4843V4.80044H16.2585V4.00014Z",
    fill: "#181425"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 4.00014H16.2585V4.80044H17.0329V4.00014Z",
    fill: "#181425"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 4.00014H17.0329V4.80044H17.8076V4.00014Z",
    fill: "#181425"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 4.00014H17.8064V4.80044H18.581V4.00014Z",
    fill: "#181425"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 4.00014H18.581V4.80044H19.3552V4.00014Z",
    fill: "#181425"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 4.00014H19.3552V4.80044H20.1293V4.00014Z",
    fill: "#181425"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 4.00014H20.1293V4.80044H20.9038V4.00014Z",
    fill: "#181425"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 4.00014H20.9038V4.80044H21.6787V4.00014Z",
    fill: "#181425"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 4.00014H21.6772V4.80044H22.4518V4.00014Z",
    fill: "#181425"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 4.00014H22.4518V4.80044H23.2263V4.00014Z",
    fill: "#181425"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 4H23.2251V4.80044H23.9997V4Z",
    fill: "#181425"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 4.80044H3.09595V5.60073H3.87055V4.80044Z",
    fill: "#181425"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 4.80044H3.87055V5.60073L4.64545 5.60097V4.80044Z",
    fill: "#181425"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 4.80044H4.64545V5.60097L5.41986 5.60073V4.80044Z",
    fill: "#181425"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 4.80044H5.41986V5.60073H6.19403V4.80044Z",
    fill: "#181425"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 4.80044H6.19403V5.60073L6.9682 5.60097V4.80044Z",
    fill: "#181425"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 4.80044H6.96704V5.60073H7.74164V4.80044Z",
    fill: "#181425"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 4.80044H7.74164V5.60073L8.5163 5.60097V4.80044Z",
    fill: "#181425"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 4.80044H8.5163V5.60097L9.29071 5.60073V4.80044Z",
    fill: "#181425"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 4.80044H9.29071V5.60073H10.0649V4.80044Z",
    fill: "#181425"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 4.80044H10.0649V5.60073L10.8391 5.60097V4.80044Z",
    fill: "#181425"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 4.80044H10.8391V5.60097L11.614 5.60073V4.80044Z",
    fill: "#181425"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 4.80044H11.6128V5.60073H12.3874V4.80044Z",
    fill: "#181425"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 4.80044H12.3874V5.60073H13.1618V4.80044Z",
    fill: "#181425"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 4.80044H13.1606V5.60073H13.9352V4.80044Z",
    fill: "#181425"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 4.80044H13.9352V5.60073L14.7101 5.60097V4.80044Z",
    fill: "#181425"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 4.80044H14.7101V5.60097L15.4843 5.60073V4.80044Z",
    fill: "#181425"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 4.80044H15.4843V5.60073H16.2585V4.80044Z",
    fill: "#181425"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 4.80044H16.2585V5.60073L17.0329 5.60097V4.80044Z",
    fill: "#181425"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 4.80044H17.0329V5.60097L17.8076 5.60073V4.80044Z",
    fill: "#181425"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 4.80044H17.8064V5.60097H18.581V4.80044Z",
    fill: "#181425"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 4.80044H18.581V5.60097L19.3552 5.60073V4.80044Z",
    fill: "#181425"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 4.80044H19.3552V5.60073H20.1293V4.80044Z",
    fill: "#181425"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 4.80044H20.1293V5.60073L20.9038 5.60097V4.80044Z",
    fill: "#181425"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 4.80044H20.9038V5.60097L21.6787 5.60073V4.80044Z",
    fill: "#181425"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 4.80044H21.6772V5.60097H22.4518V4.80044Z",
    fill: "#181425"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 4.80044H22.4518V5.60097L23.2263 5.60073V4.80044Z",
    fill: "#181425"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 4.80044H23.2251V5.60073H23.9997V4.80044Z",
    fill: "#181425"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 5.60073H3.09595V6.40029H3.87055V5.60073Z",
    fill: "#181425"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 5.59985L3.87055 5.60073V6.40029H4.64545V5.59985Z",
    fill: "#181425"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 5.60073L4.64545 5.59985V6.40029H5.41986V5.60073Z",
    fill: "#181425"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 5.60073H5.41986V6.40029H6.19403V5.60073Z",
    fill: "#181425"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 5.59985L6.19403 5.60073V6.40029H6.9682V5.59985Z",
    fill: "#181425"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 5.60073H6.96704V6.40029H7.74164V5.60073Z",
    fill: "#181425"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 5.59985L7.74164 5.60073V6.40029H8.5163V5.59985Z",
    fill: "#181425"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 5.60073L8.5163 5.59985V6.40029H9.29071V5.60073Z",
    fill: "#181425"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 5.60073H9.29071V6.40029H10.0649V5.60073Z",
    fill: "#181425"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 5.59985L10.0649 5.60073V6.40029H10.8391V5.59985Z",
    fill: "#181425"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 5.60073L10.8391 5.59985V6.40029H11.614V5.60073Z",
    fill: "#181425"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 5.60073H11.6128V6.40029H12.3874V5.60073Z",
    fill: "#181425"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 5.60073H12.3874V6.40029H13.1618V5.60073Z",
    fill: "#181425"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 5.60073H13.1606V6.40029H13.9352V5.60073Z",
    fill: "#181425"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 5.59985L13.9352 5.60073V6.40029H14.7101V5.59985Z",
    fill: "#181425"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 5.60073L14.7101 5.59985V6.40029H15.4843V5.60073Z",
    fill: "#181425"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 5.60073H15.4843V6.40029H16.2585V5.60073Z",
    fill: "#181425"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 5.59985L16.2585 5.60073V6.40029H17.0329V5.59985Z",
    fill: "#181425"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 5.60073L17.0329 5.59985V6.40029H17.8076V5.60073Z",
    fill: "#181425"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 5.59985H17.8064V6.40029H18.581V5.59985Z",
    fill: "#181425"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 5.60073L18.581 5.59985V6.40029H19.3552V5.60073Z",
    fill: "#181425"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 5.60073H19.3552V6.40029H20.1293V5.60073Z",
    fill: "#181425"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 5.59985L20.1293 5.60073V6.40029H20.9038V5.59985Z",
    fill: "#181425"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 5.60073L20.9038 5.59985V6.40029H21.6787V5.60073Z",
    fill: "#181425"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 5.59985H21.6772V6.40029H22.4518V5.59985Z",
    fill: "#181425"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 5.60073L22.4518 5.59985V6.40029H23.2263V5.60073Z",
    fill: "#181425"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 5.60073H23.2251V6.40029H23.9997V5.60073Z",
    fill: "#181425"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5495 6.40015H0.774902V7.20058H1.5495V6.40015Z",
    fill: "#181425"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 6.40015H1.54834V7.20058H2.32294V6.40015Z",
    fill: "#181425"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 6.40015H2.32294V7.20058H3.09735V6.40015Z",
    fill: "#181425"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 6.40029H3.09595V7.20058H3.87055V6.40029Z",
    fill: "#181425"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 6.40029H3.87055V7.20058H4.64545V6.40029Z",
    fill: "#181425"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 6.40029H4.64545V7.20058H5.41986V6.40029Z",
    fill: "#181425"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 6.40029H5.41986V7.20058H6.19403V6.40029Z",
    fill: "#181425"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 6.40029H6.19403V7.20058H6.9682V6.40029Z",
    fill: "#181425"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 6.40029H6.96704V7.20058H7.74164V6.40029Z",
    fill: "#181425"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 6.40029H7.74164V7.20058H8.5163V6.40029Z",
    fill: "#181425"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 6.40029H8.5163V7.20058H9.29071V6.40029Z",
    fill: "#181425"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 6.40029H9.29071V7.20058H10.0649V6.40029Z",
    fill: "#181425"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 6.40029H10.0649V7.20058H10.8391V6.40029Z",
    fill: "#181425"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 6.40029H10.8391V7.20058H11.614V6.40029Z",
    fill: "#181425"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 6.40029H11.6128V7.20058H12.3874V6.40029Z",
    fill: "#181425"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 6.40029H12.3874V7.20058H13.1618V6.40029Z",
    fill: "#181425"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 6.40029H13.1606V7.20058H13.9352V6.40029Z",
    fill: "#181425"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 6.40029H13.9352V7.20058H14.7101V6.40029Z",
    fill: "#181425"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 6.40029H14.7101V7.20058H15.4843V6.40029Z",
    fill: "#181425"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 6.40029H15.4843V7.20058H16.2585V6.40029Z",
    fill: "#181425"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 6.40029H16.2585V7.20058H17.0329V6.40029Z",
    fill: "#181425"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 6.40029H17.0329V7.20058H17.8076V6.40029Z",
    fill: "#181425"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 6.40029H17.8064V7.20058H18.581V6.40029Z",
    fill: "#181425"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 6.40029H18.581V7.20058H19.3552V6.40029Z",
    fill: "#181425"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 6.40029H19.3552V7.20058H20.1293V6.40029Z",
    fill: "#181425"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 6.40029H20.1293V7.20058H20.9038V6.40029Z",
    fill: "#181425"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 6.40029H20.9038V7.20058H21.6787V6.40029Z",
    fill: "#181425"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 6.40029H21.6772V7.20058H22.4518V6.40029Z",
    fill: "#181425"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 6.40029H22.4518V7.20058H23.2263V6.40029Z",
    fill: "#181425"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 6.40029H23.2251V7.20058H23.9997V6.40029Z",
    fill: "#181425"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M0.774902 7.20058L0 7.20068V8.00112H0.774601L0.774902 7.20058Z",
    fill: "#181425"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5495 7.20058H0.774902L0.774601 8.00112H1.5495V7.20058Z",
    fill: "#181425"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 7.20058H1.54834V8.00112H2.32294V7.20058Z",
    fill: "#181425"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 7.20058H2.32294V8.00112H3.09735V7.20058Z",
    fill: "#181425"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 7.20058H3.09595V8.00112H3.87055V7.20058Z",
    fill: "#181425"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 7.20058H3.87055V8.00112H4.64545V7.20058Z",
    fill: "#181425"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 7.20058H4.64545V8.00112H5.41986V7.20058Z",
    fill: "#181425"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 7.20058H5.41986V8.00112H6.19403V7.20058Z",
    fill: "#181425"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 7.20058H6.19403V8.00112H6.9682V7.20058Z",
    fill: "#181425"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 7.20058H6.96704V8.00112H7.74164V7.20058Z",
    fill: "#181425"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 7.20058H7.74164V8.00112H8.5163V7.20058Z",
    fill: "#181425"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 7.20058H8.5163V8.00112H9.29071V7.20058Z",
    fill: "#181425"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 7.20058H9.29071V8.00112H10.0649V7.20058Z",
    fill: "#181425"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 7.20058H10.0649V8.00112H10.8391V7.20058Z",
    fill: "#181425"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 7.20058H10.8391V8.00112H11.614V7.20058Z",
    fill: "#181425"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 7.20058H11.6128V8.00112H12.3874V7.20058Z",
    fill: "#181425"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 7.20058H12.3874V8.00112H13.1618V7.20058Z",
    fill: "#181425"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 7.20058H13.1606V8.00112H13.9352V7.20058Z",
    fill: "#181425"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 7.20058H13.9352V8.00112H14.7101V7.20058Z",
    fill: "#181425"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 7.20058H14.7101V8.00112H15.4843V7.20058Z",
    fill: "#181425"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 7.20058H15.4843V8.00112H16.2585V7.20058Z",
    fill: "#181425"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 7.20058H16.2585V8.00112H17.0329V7.20058Z",
    fill: "#181425"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 7.20058H17.0329V8.00112H17.8076V7.20058Z",
    fill: "#181425"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 7.20058H17.8064V8.00112H18.581V7.20058Z",
    fill: "#181425"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 7.20058H18.581V8.00112H19.3552V7.20058Z",
    fill: "#181425"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 7.20058H19.3552V8.00112H20.1293V7.20058Z",
    fill: "#181425"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 7.20058H20.1293V8.00112H20.9038V7.20058Z",
    fill: "#181425"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 7.20058H20.9038V8.00112H21.6787V7.20058Z",
    fill: "#181425"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 7.20058H21.6772V8.00112H22.4518V7.20058Z",
    fill: "#181425"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 7.20058H22.4518V8.00112H23.2263V7.20058Z",
    fill: "#181425"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 7.20058H23.2251V8.00112H23.9997V7.20058Z",
    fill: "#181425"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M0.774601 8H0V8.80044H0.774601V8Z",
    fill: "#181425"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5495 8H0.774601V8.80044H1.5495V8Z",
    fill: "#181425"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 8H1.54834V8.80044H2.32294V8Z",
    fill: "#181425"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 8H2.32294V8.80044H3.09735V8Z",
    fill: "#181425"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 8H3.09595V8.80044H3.87055V8Z",
    fill: "#181425"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 8H3.87055V8.80044H4.64545V8Z",
    fill: "#181425"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 8H4.64545V8.80044H5.41986V8Z",
    fill: "#181425"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 8H5.41986V8.80044H6.19403V8Z",
    fill: "#181425"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 8H6.19403V8.80044H6.9682V8Z",
    fill: "#181425"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 8H6.96704V8.80044H7.74164V8Z",
    fill: "#181425"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 8H7.74164V8.80044H8.5163V8Z",
    fill: "#181425"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 8H8.5163V8.80044H9.29071V8Z",
    fill: "#181425"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 8H9.29071V8.80044H10.0649V8Z",
    fill: "#181425"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 8H10.0649V8.80044H10.8391V8Z",
    fill: "#181425"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 8H10.8391V8.80044H11.614V8Z",
    fill: "#181425"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 8H11.6128V8.80044H12.3874V8Z",
    fill: "#181425"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 8H12.3874V8.80044H13.1618V8Z",
    fill: "#181425"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 8H13.1606V8.80044H13.9352V8Z",
    fill: "#181425"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 8H13.9352V8.80044H14.7101V8Z",
    fill: "#181425"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 8H14.7101V8.80044H15.4843V8Z",
    fill: "#181425"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 8H15.4843V8.80044H16.2585V8Z",
    fill: "#181425"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 8H16.2585V8.80044H17.0329V8Z",
    fill: "#181425"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 8H17.0329V8.80044H17.8076V8Z",
    fill: "#181425"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 8H17.8064V8.80044H18.581V8Z",
    fill: "#181425"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 8H18.581V8.80044H19.3552V8Z",
    fill: "#181425"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 8H19.3552V8.80044H20.1293V8Z",
    fill: "#181425"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 8H20.1293V8.80044H20.9038V8Z",
    fill: "#181425"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 8H20.9038V8.80044H21.6787V8Z",
    fill: "#181425"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 8H21.6772V8.80044H22.4518V8Z",
    fill: "#181425"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 8H22.4518V8.80044H23.2263V8Z",
    fill: "#181425"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 8H23.2251V8.80044H23.9997V8Z",
    fill: "#181425"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M0.774601 8.80044H0V9.60097H0.774601V8.80044Z",
    fill: "#181425"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5495 8.80044H0.774601V9.60097L1.5495 9.60073V8.80044Z",
    fill: "#181425"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 8.80044H1.54834V9.60073H2.32294V8.80044Z",
    fill: "#181425"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 8.80044H2.32294V9.60073L3.09735 9.60097V8.80044Z",
    fill: "#181425"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 8.80044H3.09595V9.60073H3.87055V8.80044Z",
    fill: "#181425"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 8.80044H3.87055V9.60073L4.64545 9.60097V8.80044Z",
    fill: "#181425"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 8.80044H4.64545V9.60097L5.41986 9.60073V8.80044Z",
    fill: "#181425"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 8.80044H5.41986V9.60073H6.19403V8.80044Z",
    fill: "#181425"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 8.80044H6.19403V9.60073L6.9682 9.60097V8.80044Z",
    fill: "#181425"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 8.80044H6.96704V9.60073H7.74164V8.80044Z",
    fill: "#181425"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 8.80044H7.74164V9.60073L8.5163 9.60097V8.80044Z",
    fill: "#181425"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 8.80044H8.5163V9.60097L9.29071 9.60073V8.80044Z",
    fill: "#181425"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 8.80044H9.29071V9.60073H10.0649V8.80044Z",
    fill: "#181425"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 8.80044H10.0649V9.60073L10.8391 9.60097V8.80044Z",
    fill: "#181425"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 8.80044H10.8391V9.60097L11.614 9.60073V8.80044Z",
    fill: "#181425"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 8.80044H11.6128V9.60073H12.3874V8.80044Z",
    fill: "#181425"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 8.80044H12.3874V9.60073H13.1618V8.80044Z",
    fill: "#181425"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 8.80044H13.1606V9.60073H13.9352V8.80044Z",
    fill: "#181425"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 8.80044H13.9352V9.60073L14.7101 9.60097V8.80044Z",
    fill: "#181425"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 8.80044H14.7101V9.60097L15.4843 9.60073V8.80044Z",
    fill: "#181425"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 8.80044H15.4843V9.60073H16.2585V8.80044Z",
    fill: "#181425"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 8.80044H16.2585V9.60073L17.0329 9.60097V8.80044Z",
    fill: "#181425"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 8.80044H17.0329V9.60097L17.8076 9.60073V8.80044Z",
    fill: "#181425"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 8.80044H17.8064V9.60097H18.581V8.80044Z",
    fill: "#181425"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 8.80044H18.581V9.60097L19.3552 9.60073V8.80044Z",
    fill: "#181425"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 8.80044H19.3552V9.60073H20.1293V8.80044Z",
    fill: "#181425"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 8.80044H20.1293V9.60073L20.9038 9.60097V8.80044Z",
    fill: "#181425"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 8.80044H20.9038V9.60097L21.6787 9.60073V8.80044Z",
    fill: "#181425"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 8.80044H21.6772V9.60097H22.4518V8.80044Z",
    fill: "#181425"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 8.80044H22.4518V9.60097L23.2263 9.60073V8.80044Z",
    fill: "#181425"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 8.80044H23.2251V9.60073H23.9997V8.80044Z",
    fill: "#181425"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5495 9.60073L0.774902 9.59985V10.4003H1.5495V9.60073Z",
    fill: "#181425"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 9.60073H1.54834V10.4003H2.32294V9.60073Z",
    fill: "#181425"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 9.59985L2.32294 9.60073V10.4003H3.09735V9.59985Z",
    fill: "#181425"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 9.60073H3.09595V10.4003H3.87055V9.60073Z",
    fill: "#181425"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 9.59985L3.87055 9.60073V10.4003H4.64545V9.59985Z",
    fill: "#181425"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 9.60073L4.64545 9.59985V10.4003H5.41986V9.60073Z",
    fill: "#181425"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 9.60073H5.41986V10.4003H6.19403V9.60073Z",
    fill: "#181425"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 9.59985L6.19403 9.60073V10.4003H6.9682V9.59985Z",
    fill: "#181425"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 9.60073H6.96704V10.4003H7.74164V9.60073Z",
    fill: "#181425"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 9.59985L7.74164 9.60073V10.4003H8.5163V9.59985Z",
    fill: "#181425"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 9.60073L8.5163 9.59985V10.4003H9.29071V9.60073Z",
    fill: "#181425"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 9.60073H9.29071V10.4003H10.0649V9.60073Z",
    fill: "#181425"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 9.59985L10.0649 9.60073V10.4003H10.8391V9.59985Z",
    fill: "#181425"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 9.60073L10.8391 9.59985V10.4003H11.614V9.60073Z",
    fill: "#181425"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 9.60073H11.6128V10.4003H12.3874V9.60073Z",
    fill: "#181425"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 9.60073H12.3874V10.4003H13.1618V9.60073Z",
    fill: "#181425"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 9.60073H13.1606V10.4003H13.9352V9.60073Z",
    fill: "#181425"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 9.59985L13.9352 9.60073V10.4003H14.7101V9.59985Z",
    fill: "#181425"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 9.60073L14.7101 9.59985V10.4003H15.4843V9.60073Z",
    fill: "#181425"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 9.60073H15.4843V10.4003H16.2585V9.60073Z",
    fill: "#181425"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 9.59985L16.2585 9.60073V10.4003H17.0329V9.59985Z",
    fill: "#181425"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 9.60073L17.0329 9.59985V10.4003H17.8076V9.60073Z",
    fill: "#181425"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 9.59985H17.8064V10.4003H18.581V9.59985Z",
    fill: "#181425"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 9.60073L18.581 9.59985V10.4003H19.3552V9.60073Z",
    fill: "#181425"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 9.60073H19.3552V10.4003H20.1293V9.60073Z",
    fill: "#181425"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 9.59985L20.1293 9.60073V10.4003H20.9038V9.59985Z",
    fill: "#181425"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 9.60073L20.9038 9.59985V10.4003H21.6787V9.60073Z",
    fill: "#181425"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 9.59985H21.6772V10.4003H22.4518V9.59985Z",
    fill: "#181425"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 9.60073L22.4518 9.59985V10.4003H23.2263V9.60073Z",
    fill: "#181425"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 9.60073H23.2251V10.4003H23.9997V9.60073Z",
    fill: "#181425"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5495 10.4003H0.774902V11.2006H1.5495V10.4003Z",
    fill: "#181425"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 10.4003H1.54834V11.2006H2.32294V10.4003Z",
    fill: "#181425"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 10.4003H2.32294V11.2006H3.09735V10.4003Z",
    fill: "#181425"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 10.4003H3.09595V11.2006H3.87055V10.4003Z",
    fill: "#181425"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 10.4003H3.87055V11.2006H4.64545V10.4003Z",
    fill: "#181425"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 10.4003H4.64545V11.2006H5.41986V10.4003Z",
    fill: "#181425"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 10.4003H5.41986V11.2006H6.19403V10.4003Z",
    fill: "#181425"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 10.4003H6.19403V11.2006H6.9682V10.4003Z",
    fill: "#181425"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 10.4003H6.96704V11.2006H7.74164V10.4003Z",
    fill: "#181425"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 10.4003H7.74164V11.2006H8.5163V10.4003Z",
    fill: "#181425"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 10.4003H8.5163V11.2006H9.29071V10.4003Z",
    fill: "#181425"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 10.4003H9.29071V11.2006H10.0649V10.4003Z",
    fill: "#181425"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 10.4003H10.0649V11.2006H10.8391V10.4003Z",
    fill: "#181425"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 10.4003H10.8391V11.2006H11.614V10.4003Z",
    fill: "#181425"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 10.4003H11.6128V11.2006H12.3874V10.4003Z",
    fill: "#181425"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 10.4003H12.3874V11.2006H13.1618V10.4003Z",
    fill: "#181425"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 10.4003H13.1606V11.2006H13.9352V10.4003Z",
    fill: "#181425"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 10.4003H13.9352V11.2006H14.7101V10.4003Z",
    fill: "#181425"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 10.4003H14.7101V11.2006H15.4843V10.4003Z",
    fill: "#181425"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 10.4003H15.4843V11.2006H16.2585V10.4003Z",
    fill: "#181425"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 10.4003H16.2585V11.2006H17.0329V10.4003Z",
    fill: "#181425"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 10.4003H17.0329V11.2006H17.8076V10.4003Z",
    fill: "#181425"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 10.4003H17.8064V11.2006H18.581V10.4003Z",
    fill: "#181425"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 10.4003H18.581V11.2006H19.3552V10.4003Z",
    fill: "#181425"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 10.4003H19.3552V11.2006H20.1293V10.4003Z",
    fill: "#181425"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 10.4003H20.1293V11.2006H20.9038V10.4003Z",
    fill: "#181425"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 10.4003H20.9038V11.2006H21.6787V10.4003Z",
    fill: "#181425"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 10.4003H21.6772V11.2006H22.4518V10.4003Z",
    fill: "#181425"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 10.4003H22.4518V11.2006H23.2263V10.4003Z",
    fill: "#181425"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 10.4003H23.2251V11.2006H23.9997V10.4003Z",
    fill: "#181425"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5495 11.2006H0.774902V12.0011H1.5495V11.2006Z",
    fill: "#181425"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 11.2006H1.54834V12.0011H2.32294V11.2006Z",
    fill: "#181425"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 11.2006H2.32294V12.0011H3.09735V11.2006Z",
    fill: "#181425"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 11.2006H3.09595V12.0011H3.87055V11.2006Z",
    fill: "#181425"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 11.2006H3.87055V12.0011H4.64545V11.2006Z",
    fill: "#181425"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 11.2006H4.64545V12.0011H5.41986V11.2006Z",
    fill: "#181425"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 11.2006H5.41986V12.0011H6.19403V11.2006Z",
    fill: "#181425"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 11.2006H6.19403V12.0011H6.9682V11.2006Z",
    fill: "#181425"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 11.2006H6.96704V12.0011H7.74164V11.2006Z",
    fill: "#181425"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 11.2006H7.74164V12.0011H8.5163V11.2006Z",
    fill: "#181425"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 11.2006H8.5163V12.0011H9.29071V11.2006Z",
    fill: "#181425"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 11.2006H9.29071V12.0011H10.0649V11.2006Z",
    fill: "#181425"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 11.2006H10.0649V12.0011H10.8391V11.2006Z",
    fill: "#181425"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 11.2006H10.8391V12.0011H11.614V11.2006Z",
    fill: "#181425"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 11.2006H11.6128V12.0011H12.3874V11.2006Z",
    fill: "#181425"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 11.2006H12.3874V12.0011H13.1618V11.2006Z",
    fill: "#181425"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 11.2006H13.1606V12.0011H13.9352V11.2006Z",
    fill: "#181425"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 11.2006H13.9352V12.0011H14.7101V11.2006Z",
    fill: "#181425"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 11.2006H14.7101V12.0011H15.4843V11.2006Z",
    fill: "#181425"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 11.2006H15.4843V12.0011H16.2585V11.2006Z",
    fill: "#181425"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 11.2006H16.2585V12.0011H17.0329V11.2006Z",
    fill: "#181425"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 11.2006H17.0329V12.0011H17.8076V11.2006Z",
    fill: "#181425"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 11.2006H17.8064V12.0011H18.581V11.2006Z",
    fill: "#181425"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 11.2006H18.581V12.0011H19.3552V11.2006Z",
    fill: "#181425"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 11.2006H19.3552V12.0011H20.1293V11.2006Z",
    fill: "#181425"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 11.2006H20.1293V12.0011H20.9038V11.2006Z",
    fill: "#181425"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 11.2006H20.9038V12.0011H21.6787V11.2006Z",
    fill: "#181425"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 11.2006H21.6772V12.0011H22.4518V11.2006Z",
    fill: "#181425"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 11.2006H22.4518V12.0011H23.2263V11.2006Z",
    fill: "#181425"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 11.2006H23.2251V12.0011H23.9997V11.2006Z",
    fill: "#181425"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 12H1.54834V12.8004H2.32294V12Z",
    fill: "#181425"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 12H2.32294V12.8004H3.09735V12Z",
    fill: "#181425"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 12H3.09595V12.8004H3.87055V12Z",
    fill: "#181425"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 12H3.87055V12.8004H4.64545V12Z",
    fill: "#181425"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 12H4.64545V12.8004H5.41986V12Z",
    fill: "#181425"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 12H5.41986V12.8004H6.19403V12Z",
    fill: "#181425"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 12H6.19403V12.8004H6.9682V12Z",
    fill: "#181425"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 12H6.96704V12.8004H7.74164V12Z",
    fill: "#181425"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 12H7.74164V12.8004H8.5163V12Z",
    fill: "#181425"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 12H8.5163V12.8004H9.29071V12Z",
    fill: "#181425"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 12H9.29071V12.8004H10.0649V12Z",
    fill: "#181425"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 12H10.0649V12.8004H10.8391V12Z",
    fill: "#181425"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 12H10.8391V12.8004H11.614V12Z",
    fill: "#181425"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 12H11.6128V12.8004H12.3874V12Z",
    fill: "#181425"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 12H12.3874V12.8004H13.1618V12Z",
    fill: "#181425"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 12H13.1606V12.8004H13.9352V12Z",
    fill: "#181425"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 12H13.9352V12.8004H14.7101V12Z",
    fill: "#181425"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 12H14.7101V12.8004H15.4843V12Z",
    fill: "#181425"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 12H15.4843V12.8004H16.2585V12Z",
    fill: "#181425"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 12H16.2585V12.8004H17.0329V12Z",
    fill: "#181425"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 12H17.0329V12.8004H17.8076V12Z",
    fill: "#181425"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 12H17.8064V12.8004H18.581V12Z",
    fill: "#181425"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 12H18.581V12.8004H19.3552V12Z",
    fill: "#181425"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 12H19.3552V12.8004H20.1293V12Z",
    fill: "#181425"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 12H20.1293V12.8004H20.9038V12Z",
    fill: "#181425"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 12H20.9038V12.8004H21.6787V12Z",
    fill: "#181425"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 12H21.6772V12.8004H22.4518V12Z",
    fill: "#181425"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 12H22.4518V12.8004H23.2263V12Z",
    fill: "#181425"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 12H23.2251V12.8004H23.9997V12Z",
    fill: "#181425"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 12.8004H1.54834V13.6007H2.32294V12.8004Z",
    fill: "#181425"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 12.8004H2.32294V13.6007L3.09735 13.601V12.8004Z",
    fill: "#181425"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 12.8004H3.09595V13.6007H3.87055V12.8004Z",
    fill: "#181425"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 12.8004H3.87055V13.6007L4.64545 13.601V12.8004Z",
    fill: "#181425"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 12.8004H4.64545V13.601L5.41986 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 12.8004H5.41986V13.6007H6.19403V12.8004Z",
    fill: "#181425"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 12.8004H6.19403V13.6007L6.9682 13.601V12.8004Z",
    fill: "#181425"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 12.8004H6.96704V13.6007H7.74164V12.8004Z",
    fill: "#181425"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 12.8004H7.74164V13.6007L8.5163 13.601V12.8004Z",
    fill: "#181425"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 12.8004H8.5163V13.601L9.29071 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 12.8004H9.29071V13.6007H10.0649V12.8004Z",
    fill: "#181425"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 12.8004H10.0649V13.6007L10.8391 13.601V12.8004Z",
    fill: "#181425"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 12.8004H10.8391V13.601L11.614 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 12.8004H11.6128V13.6007H12.3874V12.8004Z",
    fill: "#181425"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 12.8004H12.3874V13.6007H13.1618V12.8004Z",
    fill: "#181425"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 12.8004H13.1606V13.6007H13.9352V12.8004Z",
    fill: "#181425"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 12.8004H13.9352V13.6007L14.7101 13.601V12.8004Z",
    fill: "#181425"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 12.8004H14.7101V13.601L15.4843 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 12.8004H15.4843V13.6007H16.2585V12.8004Z",
    fill: "#181425"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 12.8004H16.2585V13.6007L17.0329 13.601V12.8004Z",
    fill: "#181425"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 12.8004H17.0329V13.601L17.8076 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 12.8004H17.8064V13.601H18.581V12.8004Z",
    fill: "#181425"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 12.8004H18.581V13.601L19.3552 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 12.8004H19.3552V13.6007H20.1293V12.8004Z",
    fill: "#181425"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 12.8004H20.1293V13.6007L20.9038 13.601V12.8004Z",
    fill: "#181425"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 12.8004H20.9038V13.601L21.6787 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 12.8004H21.6772V13.601H22.4518V12.8004Z",
    fill: "#181425"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 12.8004H22.4518V13.601L23.2263 13.6007V12.8004Z",
    fill: "#181425"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 12.8004H23.2251V13.6007H23.9997V12.8004Z",
    fill: "#181425"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32294 13.6007H1.54834V14.4003H2.32294V13.6007Z",
    fill: "#181425"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 13.5999L2.32294 13.6007V14.4003H3.09735V13.5999Z",
    fill: "#181425"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 13.6007H3.09595V14.4003H3.87055V13.6007Z",
    fill: "#181425"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 13.5999L3.87055 13.6007V14.4003H4.64545V13.5999Z",
    fill: "#181425"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 13.6007L4.64545 13.5999V14.4003H5.41986V13.6007Z",
    fill: "#181425"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 13.6007H5.41986V14.4003H6.19403V13.6007Z",
    fill: "#181425"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 13.5999L6.19403 13.6007V14.4003H6.9682V13.5999Z",
    fill: "#181425"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 13.6007H6.96704V14.4003H7.74164V13.6007Z",
    fill: "#181425"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 13.5999L7.74164 13.6007V14.4003H8.5163V13.5999Z",
    fill: "#181425"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 13.6007L8.5163 13.5999V14.4003H9.29071V13.6007Z",
    fill: "#181425"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 13.6007H9.29071V14.4003H10.0649V13.6007Z",
    fill: "#181425"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 13.5999L10.0649 13.6007V14.4003H10.8391V13.5999Z",
    fill: "#181425"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 13.6007L10.8391 13.5999V14.4003H11.614V13.6007Z",
    fill: "#181425"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 13.6007H11.6128V14.4003H12.3874V13.6007Z",
    fill: "#181425"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 13.6007H12.3874V14.4003H13.1618V13.6007Z",
    fill: "#181425"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 13.6007H13.1606V14.4003H13.9352V13.6007Z",
    fill: "#181425"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 13.5999L13.9352 13.6007V14.4003H14.7101V13.5999Z",
    fill: "#181425"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 13.6007L14.7101 13.5999V14.4003H15.4843V13.6007Z",
    fill: "#181425"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 13.6007H15.4843V14.4003H16.2585V13.6007Z",
    fill: "#181425"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 13.5999L16.2585 13.6007V14.4003H17.0329V13.5999Z",
    fill: "#181425"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 13.6007L17.0329 13.5999V14.4003H17.8076V13.6007Z",
    fill: "#181425"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 13.5999H17.8064V14.4003H18.581V13.5999Z",
    fill: "#181425"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 13.6007L18.581 13.5999V14.4003H19.3552V13.6007Z",
    fill: "#181425"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 13.6007H19.3552V14.4003H20.1293V13.6007Z",
    fill: "#181425"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 13.5999L20.1293 13.6007V14.4003H20.9038V13.5999Z",
    fill: "#181425"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 13.6007L20.9038 13.5999V14.4003H21.6787V13.6007Z",
    fill: "#181425"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 13.5999H21.6772V14.4003H22.4518V13.5999Z",
    fill: "#181425"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 13.6007L22.4518 13.5999V14.4003H23.2263V13.6007Z",
    fill: "#181425"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 13.6007H23.2251V14.4003H23.9997V13.6007Z",
    fill: "#181425"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 14.4003H2.32294L2.32275 15.2006H3.09735V14.4003Z",
    fill: "#181425"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 14.4003H3.09595V15.2006H3.87055V14.4003Z",
    fill: "#181425"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 14.4003H3.87055V15.2006H4.64545V14.4003Z",
    fill: "#181425"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 14.4003H4.64545V15.2006H5.41986V14.4003Z",
    fill: "#181425"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 14.4003H5.41986V15.2006H6.19403V14.4003Z",
    fill: "#181425"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 14.4003H6.19403V15.2006H6.9682V14.4003Z",
    fill: "#181425"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 14.4003H6.96704V15.2006H7.74164V14.4003Z",
    fill: "#181425"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 14.4003H7.74164V15.2006H8.5163V14.4003Z",
    fill: "#181425"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 14.4003H8.5163V15.2006H9.29071V14.4003Z",
    fill: "#181425"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 14.4003H9.29071V15.2006H10.0649V14.4003Z",
    fill: "#181425"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 14.4003H10.0649V15.2006H10.8391V14.4003Z",
    fill: "#181425"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 14.4003H10.8391V15.2006H11.614V14.4003Z",
    fill: "#181425"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 14.4003H11.6128V15.2006H12.3874V14.4003Z",
    fill: "#181425"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 14.4003H12.3874V15.2006H13.1618V14.4003Z",
    fill: "#181425"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 14.4003H13.1606V15.2006H13.9352V14.4003Z",
    fill: "#181425"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 14.4003H13.9352V15.2006H14.7101V14.4003Z",
    fill: "#181425"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 14.4003H14.7101V15.2006H15.4843V14.4003Z",
    fill: "#181425"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 14.4003H15.4843V15.2006H16.2585V14.4003Z",
    fill: "#181425"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 14.4003H16.2585V15.2006H17.0329V14.4003Z",
    fill: "#181425"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 14.4003H17.0329V15.2006H17.8076V14.4003Z",
    fill: "#181425"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 14.4003H17.8064V15.2006H18.581V14.4003Z",
    fill: "#181425"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 14.4003H18.581V15.2006H19.3552V14.4003Z",
    fill: "#181425"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 14.4003H19.3552V15.2006H20.1293V14.4003Z",
    fill: "#181425"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 14.4003H20.1293V15.2006H20.9038V14.4003Z",
    fill: "#181425"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 14.4003H20.9038V15.2006H21.6787V14.4003Z",
    fill: "#181425"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 14.4003H21.6772V15.2006H22.4518V14.4003Z",
    fill: "#181425"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 14.4003H22.4518V15.2006H23.2263V14.4003Z",
    fill: "#181425"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 14.4003H23.2251V15.2006H23.9997V14.4003Z",
    fill: "#181425"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 15.2006H2.32275V16.0011H3.09735V15.2006Z",
    fill: "#181425"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 15.2006H3.09595V16.0011H3.87055V15.2006Z",
    fill: "#181425"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 15.2006H3.87055V16.0011H4.64545V15.2006Z",
    fill: "#181425"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 15.2006H4.64545V16.0011H5.41986V15.2006Z",
    fill: "#181425"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 15.2006H5.41986V16.0011H6.19403V15.2006Z",
    fill: "#181425"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 15.2006H6.19403V16.0011H6.9682V15.2006Z",
    fill: "#181425"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 15.2006H6.96704V16.0011H7.74164V15.2006Z",
    fill: "#181425"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 15.2006H7.74164V16.0011H8.5163V15.2006Z",
    fill: "#181425"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 15.2006H8.5163V16.0011H9.29071V15.2006Z",
    fill: "#181425"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 15.2006H9.29071V16.0011H10.0649V15.2006Z",
    fill: "#181425"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 15.2006H10.0649V16.0011H10.8391V15.2006Z",
    fill: "#181425"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 15.2006H10.8391V16.0011H11.614V15.2006Z",
    fill: "#181425"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 15.2006H11.6128V16.0011H12.3874V15.2006Z",
    fill: "#181425"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 15.2006H12.3874V16.0011H13.1618V15.2006Z",
    fill: "#181425"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 15.2006H13.1606V16.0011H13.9352V15.2006Z",
    fill: "#181425"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 15.2006H13.9352V16.0011H14.7101V15.2006Z",
    fill: "#181425"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 15.2006H14.7101V16.0011H15.4843V15.2006Z",
    fill: "#181425"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 15.2006H15.4843V16.0011H16.2585V15.2006Z",
    fill: "#181425"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 15.2006H16.2585V16.0011H17.0329V15.2006Z",
    fill: "#181425"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 15.2006H17.0329V16.0011H17.8076V15.2006Z",
    fill: "#181425"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 15.2006H17.8064V16.0011H18.581V15.2006Z",
    fill: "#181425"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 15.2006H18.581V16.0011H19.3552V15.2006Z",
    fill: "#181425"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 15.2006H19.3552V16.0011H20.1293V15.2006Z",
    fill: "#181425"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 15.2006H20.1293V16.0011H20.9038V15.2006Z",
    fill: "#181425"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 15.2006H20.9038V16.0011H21.6787V15.2006Z",
    fill: "#181425"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 15.2006H21.6772V16.0011H22.4518V15.2006Z",
    fill: "#181425"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 15.2006H22.4518V16.0011H23.2263V15.2006Z",
    fill: "#181425"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 15.2006H23.2251V16.0011H23.9997V15.2006Z",
    fill: "#181425"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09735 16H2.32275V16.8004H3.09735V16Z",
    fill: "#181425"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 16H3.09595V16.8004H3.87055V16Z",
    fill: "#181425"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 16H3.87055V16.8004H4.64545V16Z",
    fill: "#181425"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 16H4.64545V16.8004H5.41986V16Z",
    fill: "#181425"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 16H5.41986V16.8004H6.19403V16Z",
    fill: "#181425"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 16H6.19403V16.8004H6.9682V16Z",
    fill: "#181425"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 16H6.96704V16.8004H7.74164V16Z",
    fill: "#181425"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 16H7.74164V16.8004H8.5163V16Z",
    fill: "#181425"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 16H8.5163V16.8004H9.29071V16Z",
    fill: "#181425"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 16H9.29071V16.8004H10.0649V16Z",
    fill: "#181425"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 16H10.0649V16.8004H10.8391V16Z",
    fill: "#181425"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 16H10.8391V16.8004H11.614V16Z",
    fill: "#181425"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 16H11.6128V16.8004H12.3874V16Z",
    fill: "#181425"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 16H12.3874V16.8004H13.1618V16Z",
    fill: "#181425"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 16H13.1606V16.8004H13.9352V16Z",
    fill: "#181425"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 16H13.9352V16.8004H14.7101V16Z",
    fill: "#181425"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 16H14.7101V16.8004H15.4843V16Z",
    fill: "#181425"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 16H15.4843V16.8004H16.2585V16Z",
    fill: "#181425"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 16H16.2585V16.8004H17.0329V16Z",
    fill: "#181425"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 16H17.0329V16.8004H17.8076V16Z",
    fill: "#181425"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 16H17.8064V16.8004H18.581V16Z",
    fill: "#181425"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 16H18.581V16.8004H19.3552V16Z",
    fill: "#181425"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 16H19.3552V16.8004H20.1293V16Z",
    fill: "#181425"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 16H20.1293V16.8004H20.9038V16Z",
    fill: "#181425"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 16H20.9038V16.8004H21.6787V16Z",
    fill: "#181425"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 16H21.6772V16.8004H22.4518V16Z",
    fill: "#181425"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 16H22.4518V16.8004H23.2263V16Z",
    fill: "#181425"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 16H23.2251V16.8004H23.9997V16Z",
    fill: "#181425"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 16.8004H3.09595V17.6007H3.87055V16.8004Z",
    fill: "#181425"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 16.8004H3.87055V17.6007L4.64545 17.601V16.8004Z",
    fill: "#181425"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 16.8004H4.64545V17.601L5.41986 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 16.8004H5.41986V17.6007H6.19403V16.8004Z",
    fill: "#181425"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 16.8004H6.19403V17.6007L6.9682 17.601V16.8004Z",
    fill: "#181425"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 16.8004H6.96704V17.6007H7.74164V16.8004Z",
    fill: "#181425"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 16.8004H7.74164V17.6007L8.5163 17.601V16.8004Z",
    fill: "#181425"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 16.8004H8.5163V17.601L9.29071 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 16.8004H9.29071V17.6007H10.0649V16.8004Z",
    fill: "#181425"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 16.8004H10.0649V17.6007L10.8391 17.601V16.8004Z",
    fill: "#181425"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 16.8004H10.8391V17.601L11.614 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 16.8004H11.6128V17.6007H12.3874V16.8004Z",
    fill: "#181425"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 16.8004H12.3874V17.6007H13.1618V16.8004Z",
    fill: "#181425"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 16.8004H13.1606V17.6007H13.9352V16.8004Z",
    fill: "#181425"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 16.8004H13.9352V17.6007L14.7101 17.601V16.8004Z",
    fill: "#181425"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 16.8004H14.7101V17.601L15.4843 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 16.8004H15.4843V17.6007H16.2585V16.8004Z",
    fill: "#181425"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 16.8004H16.2585V17.6007L17.0329 17.601V16.8004Z",
    fill: "#181425"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 16.8004H17.0329V17.601L17.8076 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 16.8004H17.8064V17.601H18.581V16.8004Z",
    fill: "#181425"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 16.8004H18.581V17.601L19.3552 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 16.8004H19.3552V17.6007H20.1293V16.8004Z",
    fill: "#181425"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 16.8004H20.1293V17.6007L20.9038 17.601V16.8004Z",
    fill: "#181425"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 16.8004H20.9038V17.601L21.6787 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 16.8004H21.6772V17.601H22.4518V16.8004Z",
    fill: "#181425"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 16.8004H22.4518V17.601L23.2263 17.6007V16.8004Z",
    fill: "#181425"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 16.8004H23.2251V17.6007H23.9997V16.8004Z",
    fill: "#181425"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 17.6007H3.09595V18.4015H3.87055V17.6007Z",
    fill: "#181425"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 17.601L3.87055 17.6007V18.4015L4.64545 18.4013V17.601Z",
    fill: "#181425"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 17.6007L4.64545 17.601V18.4013L5.41986 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 17.6007H5.41986V18.4015H6.19403V17.6007Z",
    fill: "#181425"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 17.601L6.19403 17.6007V18.4015L6.9682 18.4013V17.601Z",
    fill: "#181425"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 17.6007H6.96704V18.4015H7.74164V17.6007Z",
    fill: "#181425"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 17.601L7.74164 17.6007V18.4015L8.5163 18.4013V17.601Z",
    fill: "#181425"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 17.6007L8.5163 17.601V18.4013L9.29071 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 17.6007H9.29071V18.4015H10.0649V17.6007Z",
    fill: "#181425"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 17.601L10.0649 17.6007V18.4015L10.8391 18.4013V17.601Z",
    fill: "#181425"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 17.6007L10.8391 17.601V18.4013L11.614 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 17.6007H11.6128V18.4015H12.3874V17.6007Z",
    fill: "#181425"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 17.6007H12.3874V18.4015H13.1618V17.6007Z",
    fill: "#181425"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 17.6007H13.1606V18.4015H13.9352V17.6007Z",
    fill: "#181425"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 17.601L13.9352 17.6007V18.4015L14.7101 18.4013V17.601Z",
    fill: "#181425"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 17.6007L14.7101 17.601V18.4013L15.4843 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 17.6007H15.4843V18.4015H16.2585V17.6007Z",
    fill: "#181425"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 17.601L16.2585 17.6007V18.4015L17.0329 18.4013V17.601Z",
    fill: "#181425"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 17.6007L17.0329 17.601V18.4013L17.8076 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 17.601H17.8064V18.4013H18.581V17.601Z",
    fill: "#181425"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 17.6007L18.581 17.601V18.4013L19.3552 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 17.6007H19.3552V18.4015H20.1293V17.6007Z",
    fill: "#181425"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 17.601L20.1293 17.6007V18.4015L20.9038 18.4013V17.601Z",
    fill: "#181425"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 17.6007L20.9038 17.601V18.4013L21.6787 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 17.601H21.6772V18.4013H22.4518V17.601Z",
    fill: "#181425"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 17.6007L22.4518 17.601V18.4013L23.2263 18.4015V17.6007Z",
    fill: "#181425"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 17.6007H23.2251V18.4015H23.9997V17.6007Z",
    fill: "#181425"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87055 18.4001H3.09595V19.2006H3.87055V18.4001Z",
    fill: "#181425"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 18.4001H3.87055V19.2006H4.64545V18.4001Z",
    fill: "#181425"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 18.4001H4.64545V19.2006H5.41986V18.4001Z",
    fill: "#181425"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 18.4001H5.41986V19.2006H6.19403V18.4001Z",
    fill: "#181425"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 18.4001H6.19403V19.2006H6.9682V18.4001Z",
    fill: "#181425"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 18.4001H6.96704V19.2006H7.74164V18.4001Z",
    fill: "#181425"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 18.4001H7.74164V19.2006H8.5163V18.4001Z",
    fill: "#181425"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 18.4001H8.5163V19.2006H9.29071V18.4001Z",
    fill: "#181425"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 18.4001H9.29071V19.2006H10.0649V18.4001Z",
    fill: "#181425"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 18.4001H10.0649V19.2006H10.8391V18.4001Z",
    fill: "#181425"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 18.4001H10.8391V19.2006H11.614V18.4001Z",
    fill: "#181425"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 18.4001H11.6128V19.2006H12.3874V18.4001Z",
    fill: "#181425"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 18.4001H12.3874V19.2006H13.1618V18.4001Z",
    fill: "#181425"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 18.4001H13.1606V19.2006H13.9352V18.4001Z",
    fill: "#181425"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 18.4001H13.9352V19.2006H14.7101V18.4001Z",
    fill: "#181425"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 18.4001H14.7101V19.2006H15.4843V18.4001Z",
    fill: "#181425"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 18.4001H15.4843V19.2006H16.2585V18.4001Z",
    fill: "#181425"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 18.4001H16.2585V19.2006H17.0329V18.4001Z",
    fill: "#181425"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 18.4001H17.0329V19.2006H17.8076V18.4001Z",
    fill: "#181425"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 18.4001H17.8064V19.2006H18.581V18.4001Z",
    fill: "#181425"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 18.4001H18.581V19.2006H19.3552V18.4001Z",
    fill: "#181425"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 18.4001H19.3552V19.2006H20.1293V18.4001Z",
    fill: "#181425"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 18.4001H20.1293V19.2006H20.9038V18.4001Z",
    fill: "#181425"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 18.4001H20.9038V19.2006H21.6787V18.4001Z",
    fill: "#181425"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 18.4001H21.6772V19.2006H22.4518V18.4001Z",
    fill: "#181425"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 18.4001H22.4518V19.2006H23.2263V18.4001Z",
    fill: "#181425"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 18.4001H23.2251V19.2006H23.9997V18.4001Z",
    fill: "#181425"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 19.2006H3.87055L3.87085 20.0011H4.64545V19.2006Z",
    fill: "#181425"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41986 19.2006H4.64545V20.0011H5.41986V19.2006Z",
    fill: "#181425"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19403 19.2006H5.41986V20.0011H6.19403V19.2006Z",
    fill: "#181425"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9682 19.2006H6.19403V20.0011H6.9682V19.2006Z",
    fill: "#181425"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 19.2006H6.96704V20.0011H7.74164V19.2006Z",
    fill: "#181425"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5163 19.2006H7.74164V20.0011H8.5163V19.2006Z",
    fill: "#181425"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29071 19.2006H8.5163V20.0011H9.29071V19.2006Z",
    fill: "#181425"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0649 19.2006H9.29071V20.0011H10.0649V19.2006Z",
    fill: "#181425"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 19.2006H10.0649V20.0011H10.8391V19.2006Z",
    fill: "#181425"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M11.614 19.2006H10.8391V20.0011H11.614V19.2006Z",
    fill: "#181425"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3874 19.2006H11.6128V20.0011H12.3874V19.2006Z",
    fill: "#181425"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1618 19.2006H12.3874V20.0011H13.1618V19.2006Z",
    fill: "#181425"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 19.2006H13.1606V20.0011H13.9352V19.2006Z",
    fill: "#181425"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7101 19.2006H13.9352V20.0011H14.7101V19.2006Z",
    fill: "#181425"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4843 19.2006H14.7101V20.0011H15.4843V19.2006Z",
    fill: "#181425"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 19.2006H15.4843V20.0011H16.2585V19.2006Z",
    fill: "#181425"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 19.2006H16.2585V20.0011H17.0329V19.2006Z",
    fill: "#181425"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 19.2006H17.0329V20.0011H17.8076V19.2006Z",
    fill: "#181425"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 19.2006H17.8064V20.0011H18.581V19.2006Z",
    fill: "#181425"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3552 19.2006H18.581V20.0011H19.3552V19.2006Z",
    fill: "#181425"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 19.2006H19.3552V20.0011H20.1293V19.2006Z",
    fill: "#181425"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9038 19.2006H20.1293V20.0011H20.9038V19.2006Z",
    fill: "#181425"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 19.2006H20.9038V20.0011H21.6787V19.2006Z",
    fill: "#181425"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4518 19.2006H21.6772V20.0011H22.4518V19.2006Z",
    fill: "#181425"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2263 19.2006H22.4518V20.0011H23.2263V19.2006Z",
    fill: "#181425"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_14421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.cd10e006153da2311a205631ed690172.svg";
export { ForwardRef as ReactComponent };